var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1024px",
    height: "1024px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5896f3",
    d: "M 327.5,82.5 C 328.833,83.1667 328.833,83.1667 327.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5995f3",
    d: "M 359.5,82.5 C 360.833,83.1667 360.833,83.1667 359.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#639bee",
    d: "M 409.5,83.5 C 410.833,84.1667 410.833,84.1667 409.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#5096fe",
    d: "M 414.5,88.5 C 415.73,90.2972 416.396,92.2972 416.5,94.5C 416.5,102.833 416.5,111.167 416.5,119.5C 416.167,119.5 415.833,119.5 415.5,119.5C 340.167,119.5 264.833,119.5 189.5,119.5C 189.334,110.494 189.5,101.494 190,92.5C 191.167,88.6667 193.667,86.1667 197.5,85C 206.744,84.8192 215.911,84.3192 225,83.5C 272.558,84.5606 320.392,84.5606 368.5,83.5C 381.788,84.3155 395.122,84.8155 408.5,85C 410.887,85.5637 412.887,86.7304 414.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#5e9cef",
    d: "M 414.5,87.5 C 415.833,88.1667 415.833,88.1667 414.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#5589da",
    d: "M 187.5,93.5 C 188.833,94.1667 188.833,94.1667 187.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6da6f1",
    d: "M 418.5,96.5 C 419.833,97.1667 419.833,97.1667 418.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#95c8f3",
    d: "M 479.5,98.5 C 480.833,99.1667 480.833,99.1667 479.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#95caf0",
    d: "M 483.5,100.5 C 484.833,101.167 484.833,101.167 483.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#96cbf0",
    d: "M 493.5,103.5 C 494.833,104.167 494.833,104.167 493.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#96caf2",
    d: "M 502.5,105.5 C 503.773,106.077 503.773,106.743 502.5,107.5C 501.537,107.03 501.537,106.363 502.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#95c9f2",
    d: "M 518.5,113.5 C 515.791,111.868 516.125,111.368 519.5,112C 520.712,113.107 520.379,113.607 518.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#95cbf5",
    d: "M 521.5,113.5 C 522.833,114.167 522.833,114.167 521.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#96cbf5",
    d: "M 524.5,114.5 C 523.833,113.167 523.833,113.167 524.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#97caf2",
    d: "M 524.5,115.5 C 524.5,115.167 524.5,114.833 524.5,114.5C 528.5,114.833 528.5,115.167 524.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#99ccf0",
    d: "M 530.5,116.5 C 531.833,117.167 531.833,117.167 530.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0b43a6",
    d: "M 189.5,119.5 C 264.833,119.5 340.167,119.5 415.5,119.5C 340.668,120.333 265.668,120.833 190.5,121C 265.499,121.5 340.499,121.667 415.5,121.5C 415.5,130.5 415.5,139.5 415.5,148.5C 340.499,148.333 265.499,148.5 190.5,149C 265.833,149.5 341.166,149.667 416.5,149.5C 341.002,150.499 265.335,150.833 189.5,150.5C 189.5,140.167 189.5,129.833 189.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#97cbf1",
    d: "M 550.5,122.5 C 551.833,123.167 551.833,123.167 550.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#4374c5",
    d: "M 187.5,123.5 C 188.833,124.167 188.833,124.167 187.5,123.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.005
    },
    fill: "#96c9f2",
    d: "M 563.5,128.5 C 564.849,127.203 566.182,127.37 567.5,129C 566.906,129.464 566.239,129.631 565.5,129.5C 565.158,128.662 564.492,128.328 563.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#426fbd",
    d: "M 183.5,128.5 C 184.833,129.167 184.833,129.167 183.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#99cbf2",
    d: "M 572.5,130.5 C 573.833,131.167 573.833,131.167 572.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#96caf1",
    d: "M 586.5,135.5 C 587.833,136.167 587.833,136.167 586.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#96c9f0",
    d: "M 589.5,137.5 C 589.897,136.475 590.563,136.308 591.5,137C 590.906,137.464 590.239,137.631 589.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#97c8ef",
    d: "M 593.5,136.5 C 594.833,137.167 594.833,137.167 593.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3e6fbf",
    d: "M 187.5,137.5 C 188.833,138.167 188.833,138.167 187.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#96cbf1",
    d: "M 593.5,137.5 C 592.833,138.167 592.833,138.167 593.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#99ccf1",
    d: "M 595.5,138.5 C 596.833,139.167 596.833,139.167 595.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9accef",
    d: "M 603.5,141.5 C 604.833,142.167 604.833,142.167 603.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3e6ec4",
    d: "M 187.5,144.5 C 188.833,145.167 188.833,145.167 187.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#98caee",
    d: "M 614.5,144.5 C 615.833,145.167 615.833,145.167 614.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#96cbf2",
    d: "M 616.5,146.5 C 616.897,145.475 617.563,145.308 618.5,146C 617.906,146.464 617.239,146.631 616.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#97cbf1",
    d: "M 619.5,146.5 C 620.833,147.167 620.833,147.167 619.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#4374c7",
    d: "M 186.5,147.5 C 187.833,148.167 187.833,148.167 186.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#96c9f4",
    d: "M 622.5,147.5 C 623.833,148.167 623.833,148.167 622.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#001473",
    d: "M 415.5,119.5 C 415.833,119.5 416.167,119.5 416.5,119.5C 416.5,129.5 416.5,139.5 416.5,149.5C 341.166,149.667 265.833,149.5 190.5,149C 265.499,148.5 340.499,148.333 415.5,148.5C 415.5,139.5 415.5,130.5 415.5,121.5C 340.499,121.667 265.499,121.5 190.5,121C 265.668,120.833 340.668,120.333 415.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#4c7fcd",
    d: "M 186.5,150.5 C 187.833,151.167 187.833,151.167 186.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#96c8ef",
    d: "M 632.5,151.5 C 633.833,152.167 633.833,152.167 632.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#4f95fe",
    d: "M 189.5,151.5 C 265.167,151.5 340.833,151.5 416.5,151.5C 416.5,172.833 416.5,194.167 416.5,215.5C 416.365,219.627 414.365,222.294 410.5,223.5C 340.027,224.157 269.694,224.824 199.5,225.5C 191.225,221.957 187.892,215.624 189.5,206.5C 189.5,188.167 189.5,169.833 189.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#97cbef",
    d: "M 635.5,152.5 C 636.833,153.167 636.833,153.167 635.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#95c9f0",
    d: "M 637.5,152.5 C 638.833,153.167 638.833,153.167 637.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#98cbf1",
    d: "M 641.5,154.5 C 642.833,155.167 642.833,155.167 641.5,154.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#94cefd",
    d: "M 416.5,94.5 C 417.329,102.657 417.829,110.99 418,119.5C 434.011,114.773 449.845,109.773 465.5,104.5C 470.497,103.709 475.33,102.376 480,100.5C 492.592,105.531 505.426,109.864 518.5,113.5C 519.209,114.404 520.209,114.737 521.5,114.5C 522.209,115.404 523.209,115.737 524.5,115.5C 526.214,116.738 528.214,117.405 530.5,117.5C 533.692,119.73 537.192,120.396 541,119.5C 542.697,120.478 543.864,121.644 544.5,123C 550.825,124.997 557.158,126.83 563.5,128.5C 563.842,129.338 564.508,129.672 565.5,129.5C 574.233,133.078 583.233,136.078 592.5,138.5C 595.797,140.601 599.463,141.935 603.5,142.5C 607.502,144.61 611.835,145.943 616.5,146.5C 621.382,149.464 626.715,151.464 632.5,152.5C 633.209,153.404 634.209,153.737 635.5,153.5C 637.214,154.738 639.214,155.405 641.5,155.5C 646.878,157.96 652.878,159.96 659.5,161.5C 679.141,168.811 698.141,175.478 716.5,181.5C 719.215,183.072 722.215,184.072 725.5,184.5C 732.954,187.541 740.62,190.208 748.5,192.5C 755.529,195.236 762.696,197.902 770,200.5C 771.997,199.34 773.831,199.34 775.5,200.5C 774.448,200.351 773.448,200.517 772.5,201C 774.025,202.009 775.692,202.509 777.5,202.5C 782.299,204.723 787.299,206.723 792.5,208.5C 795.484,207.035 798.151,207.369 800.5,209.5C 796.5,209.833 796.5,210.167 800.5,210.5C 805.537,213.071 810.871,215.071 816.5,216.5C 817.209,217.404 818.209,217.737 819.5,217.5C 819.56,218.043 819.893,218.376 820.5,218.5C 821.167,217.833 821.833,217.167 822.5,216.5C 823.711,217.274 823.711,218.107 822.5,219C 824.058,219.21 825.391,219.71 826.5,220.5C 756.833,220.5 687.167,220.5 617.5,220.5C 612.65,217.245 607.317,214.745 601.5,213C 560.075,198.636 518.575,184.469 477,170.5C 457.462,177.402 437.962,184.402 418.5,191.5C 417.833,199.657 417.167,207.657 416.5,215.5C 416.5,194.167 416.5,172.833 416.5,151.5C 340.833,151.5 265.167,151.5 189.5,151.5C 189.5,151.167 189.5,150.833 189.5,150.5C 265.335,150.833 341.002,150.499 416.5,149.5C 416.5,139.5 416.5,129.5 416.5,119.5C 416.5,111.167 416.5,102.833 416.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#79b2f3",
    d: "M 418.5,117.5 C 418.897,116.475 419.563,116.308 420.5,117C 419.906,117.464 419.239,117.631 418.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#85bdf5",
    d: "M 424.5,115.5 C 424.897,114.475 425.563,114.308 426.5,115C 425.906,115.464 425.239,115.631 424.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#79b4f6",
    d: "M 419.5,114.5 C 420.833,115.167 420.833,115.167 419.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#8ac0f3",
    d: "M 430.5,113.5 C 431.833,114.167 431.833,114.167 430.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#90c6f4",
    d: "M 443.5,109.5 C 444.833,110.167 444.833,110.167 443.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#92c6f3",
    d: "M 448.5,107.5 C 449.833,108.167 449.833,108.167 448.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#6fa9f3",
    d: "M 418.5,106.5 C 419.573,107.251 419.74,108.251 419,109.5C 418.517,108.552 418.351,107.552 418.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#94c9f7",
    d: "M 456.5,105.5 C 457.833,106.167 457.833,106.167 456.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#92c9f5",
    d: "M 459.5,104.5 C 460.833,105.167 460.833,105.167 459.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6fa9f2",
    d: "M 418.5,104.5 C 419.833,105.167 419.833,105.167 418.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.014
    },
    fill: "#94caf4",
    d: "M 465.5,104.5 C 464.761,104.631 464.094,104.464 463.5,104C 464.437,103.308 465.103,103.475 465.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.007
    },
    fill: "#97caf0",
    d: "M 659.5,160.5 C 658.448,160.649 657.448,160.483 656.5,160C 657.749,159.26 658.749,159.427 659.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#96ccee",
    d: "M 659.5,160.5 C 660.833,161.167 660.833,161.167 659.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#99c9ef",
    d: "M 663.5,161.5 C 664.833,162.167 664.833,162.167 663.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#99ccef",
    d: "M 665.5,162.5 C 666.833,163.167 666.833,163.167 665.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9acaed",
    d: "M 669.5,162.5 C 670.833,163.167 670.833,163.167 669.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5b90e8",
    d: "M 187.5,163.5 C 188.833,164.167 188.833,164.167 187.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#5cacfc",
    d: "M 398.5,168.5 C 379.833,168.5 361.167,168.5 342.5,168.5C 341.508,168.328 340.842,168.662 340.5,169.5C 339.5,170.167 338.5,170.833 337.5,171.5C 337.859,169.629 338.859,168.129 340.5,167C 359.5,166.333 378.5,166.333 397.5,167C 398.056,167.383 398.389,167.883 398.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#97caec",
    d: "M 680.5,167.5 C 681.833,168.167 681.833,168.167 680.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#96caed",
    d: "M 683.5,168.5 C 684.833,169.167 684.833,169.167 683.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#98cbef",
    d: "M 689.5,170.5 C 690.833,171.167 690.833,171.167 689.5,170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0c44a8",
    d: "M 340.5,169.5 C 340.842,168.662 341.508,168.328 342.5,168.5C 360.329,169.332 378.329,169.832 396.5,170C 399.917,172.321 400.25,174.988 397.5,178C 378.833,178.667 360.167,178.667 341.5,178C 338.833,175.333 338.833,172.667 341.5,170C 341.272,169.601 340.938,169.435 340.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#98c8eb",
    d: "M 704.5,175.5 C 705.833,176.167 705.833,176.167 704.5,175.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#97c8ed",
    d: "M 707.5,176.5 C 708.833,177.167 708.833,177.167 707.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#98c8ec",
    d: "M 709.5,178.5 C 709.897,177.475 710.563,177.308 711.5,178C 710.906,178.464 710.239,178.631 709.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#011170",
    d: "M 342.5,168.5 C 361.167,168.5 379.833,168.5 398.5,168.5C 400.168,170.479 400.834,172.812 400.5,175.5C 400.489,177.017 399.823,178.184 398.5,179C 379.167,179.667 359.833,179.667 340.5,179C 337.959,177.152 336.959,174.652 337.5,171.5C 338.5,170.833 339.5,170.167 340.5,169.5C 340.938,169.435 341.272,169.601 341.5,170C 338.833,172.667 338.833,175.333 341.5,178C 360.167,178.667 378.833,178.667 397.5,178C 400.25,174.988 399.917,172.321 396.5,170C 378.329,169.832 360.329,169.332 342.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#99c9ec",
    d: "M 716.5,180.5 C 715.833,179.167 715.833,179.167 716.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5facfc",
    d: "M 337.5,171.5 C 336.959,174.652 337.959,177.152 340.5,179C 359.833,179.667 379.167,179.667 398.5,179C 399.823,178.184 400.489,177.017 400.5,175.5C 401.268,174.737 401.768,173.737 402,172.5C 402.753,176.493 401.253,179.326 397.5,181C 378.833,181.667 360.167,181.667 341.5,181C 336.788,179.118 335.455,175.951 337.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#98c8eb",
    d: "M 716.5,180.5 C 717.833,181.167 717.833,181.167 716.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#dbf0fe",
    d: "M 617.5,220.5 C 608.651,220.174 599.984,220.507 591.5,221.5C 586.32,222.512 582.82,225.512 581,230.5C 580.5,254.831 580.333,279.164 580.5,303.5C 582.35,308.849 586.016,312.349 591.5,314C 650.166,314.5 708.832,314.667 767.5,314.5C 761.703,367.357 750.37,419.023 733.5,469.5C 733.863,470.183 734.196,470.85 734.5,471.5C 723.468,467.156 712.135,463.823 700.5,461.5C 706.823,453.856 711.323,445.19 714,435.5C 726.147,432.558 729.314,425.558 723.5,414.5C 727.019,394.81 724.186,376.143 715,358.5C 705.158,346.325 692.325,339.492 676.5,338C 662.86,335.996 649.86,337.996 637.5,344C 630.979,347.182 626.646,352.182 624.5,359C 619.427,360.406 615.927,363.572 614,368.5C 608.547,383.687 608.047,399.02 612.5,414.5C 607.777,421.605 608.777,427.771 615.5,433C 617.955,434.312 620.455,435.478 623,436.5C 625.958,445.754 630.458,454.088 636.5,461.5C 618.721,465.112 601.388,470.279 584.5,477C 574.81,481.195 567.144,487.695 561.5,496.5C 558.479,499.366 555.979,502.7 554,506.5C 546.119,524.651 537.952,542.651 529.5,560.5C 523.53,569.325 517.696,578.325 512,587.5C 509.594,594.65 508.927,601.983 510,609.5C 514.281,630.379 522.115,649.712 533.5,667.5C 514.153,671.193 494.819,675.027 475.5,679C 456.529,689.44 448.696,705.274 452,726.5C 457.229,735.894 464.062,743.894 472.5,750.5C 453.878,740.589 446.545,725.256 450.5,704.5C 450.471,702.971 449.804,701.804 448.5,701C 413.625,679.789 382.459,653.956 355,623.5C 349.979,627.426 344.479,630.426 338.5,632.5C 344.463,628.513 350.463,624.513 356.5,620.5C 363.606,615.595 367.439,608.929 368,600.5C 364.235,594.24 358.735,592.073 351.5,594C 339.726,597.968 327.893,601.801 316,605.5C 314.893,605.415 313.893,605.081 313,604.5C 312.333,602.5 312.333,600.5 313,598.5C 315.383,595.727 318.217,593.561 321.5,592C 336.807,585.016 351.474,577.016 365.5,568C 371.769,563.449 375.769,557.449 377.5,550C 377.01,547.497 375.677,545.497 373.5,544C 369.167,543.333 364.833,543.333 360.5,544C 352.395,547.035 344.228,549.868 336,552.5C 332.836,552.233 331.836,550.567 333,547.5C 335.167,545.333 337.333,543.167 339.5,541C 355.385,531.113 370.719,520.446 385.5,509C 390.673,503.985 394.006,497.985 395.5,491C 395.091,486.521 392.758,483.521 388.5,482C 384.833,481.333 381.167,481.333 377.5,482C 365.336,488.035 353.336,494.202 341.5,500.5C 341.5,498.833 341.5,497.167 341.5,495.5C 342.031,492.763 342.864,490.096 344,487.5C 352.543,471.748 360.543,455.748 368,439.5C 371.632,430.016 372.299,420.349 370,410.5C 364.175,403.93 357.342,402.763 349.5,407C 343.181,412.983 338.014,419.816 334,427.5C 328.679,439.13 324.345,451.13 321,463.5C 320.623,464.942 319.79,465.942 318.5,466.5C 318.5,465.833 318.167,465.5 317.5,465.5C 316.316,456.781 313.816,448.448 310,440.5C 304,433.833 298,433.833 292,440.5C 290.092,443.215 288.759,446.215 288,449.5C 286.63,457.764 286.13,466.097 286.5,474.5C 286.85,480.951 287.85,487.284 289.5,493.5C 286.202,495.485 282.869,497.485 279.5,499.5C 275.487,495.485 271.821,491.152 268.5,486.5C 268.435,486.062 268.601,485.728 269,485.5C 270.6,486.866 272.433,487.866 274.5,488.5C 273.833,488.833 273.167,489.167 272.5,489.5C 274.38,492.091 276.38,494.591 278.5,497C 279.725,497.563 280.725,497.23 281.5,496C 277.604,489.691 273.604,483.525 269.5,477.5C 274.068,465.568 276.234,453.235 276,440.5C 271.748,430.281 264.915,427.948 255.5,433.5C 236.988,379.118 226.488,323.118 224,265.5C 254.958,252.955 286.125,240.789 317.5,229C 319.727,228.059 321.727,226.892 323.5,225.5C 351.835,225.667 380.169,225.5 408.5,225C 409.416,224.722 410.082,224.222 410.5,223.5C 414.365,222.294 416.365,219.627 416.5,215.5C 417.167,207.657 417.833,199.657 418.5,191.5C 437.962,184.402 457.462,177.402 477,170.5C 518.575,184.469 560.075,198.636 601.5,213C 607.317,214.745 612.65,217.245 617.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#9ac9ec",
    d: "M 725.5,184.5 C 726.251,183.427 727.251,183.26 728.5,184C 727.552,184.483 726.552,184.649 725.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9bc9ec",
    d: "M 735.5,187.5 C 735.897,186.475 736.563,186.308 737.5,187C 736.906,187.464 736.239,187.631 735.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.013
    },
    fill: "#9acaeb",
    d: "M 748.5,192.5 C 749.251,191.427 750.251,191.26 751.5,192C 750.552,192.483 749.552,192.649 748.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#9dcdeb",
    d: "M 755.5,193.5 C 756.833,194.167 756.833,194.167 755.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a0c7df",
    d: "M 766.5,194.5 C 767.833,195.167 767.833,195.167 766.5,194.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a2cae5",
    d: "M 766.5,197.5 C 767.833,198.167 767.833,198.167 766.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#05278b",
    d: "M 397.5,190.5 C 402.343,193.553 402.676,197.053 398.5,201C 388.172,201.5 377.839,201.666 367.5,201.5C 364.045,198.275 363.711,194.775 366.5,191C 376.828,190.5 387.161,190.334 397.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0c45a7",
    d: "M 367.5,191.5 C 377.506,191.334 387.506,191.5 397.5,192C 399.648,194.075 399.982,196.408 398.5,199C 388.167,199.667 377.833,199.667 367.5,199C 366.221,196.502 366.221,194.002 367.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#a2cae2",
    d: "M 775.5,200.5 C 776.833,201.167 776.833,201.167 775.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#71bffd",
    d: "M 397.5,190.5 C 399.398,189.515 400.898,190.182 402,192.5C 403.183,196.274 402.349,199.441 399.5,202C 388.659,202.825 377.992,202.659 367.5,201.5C 377.839,201.666 388.172,201.5 398.5,201C 402.676,197.053 402.343,193.553 397.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#a3cae4",
    d: "M 777.5,202.5 C 778.251,201.427 779.251,201.26 780.5,202C 779.552,202.483 778.552,202.649 777.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#7cb3f5",
    d: "M 186.5,205.5 C 186.897,204.475 187.563,204.308 188.5,205C 187.906,205.464 187.239,205.631 186.5,205.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#8fc0f1",
    d: "M 180.5,207.5 C 181.833,208.167 181.833,208.167 180.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#b1c6cb",
    d: "M 801.5,207.5 C 802.833,208.167 802.833,208.167 801.5,207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#92c3f0",
    d: "M 173.5,209.5 C 174.833,210.167 174.833,210.167 173.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#aec8d1",
    d: "M 800.5,210.5 C 800.5,210.167 800.5,209.833 800.5,209.5C 803.167,209.833 803.167,210.167 800.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#92c5f1",
    d: "M 169.5,210.5 C 170.833,211.167 170.833,211.167 169.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#b5c8cd",
    d: "M 803.5,210.5 C 804.833,211.167 804.833,211.167 803.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#b6c7c6",
    d: "M 806.5,210.5 C 807.525,210.897 807.692,211.563 807,212.5C 806.536,211.906 806.369,211.239 806.5,210.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#bdc4c0",
    d: "M 816.5,215.5 C 817.833,216.167 817.833,216.167 816.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#bfc2b2",
    d: "M 819.5,217.5 C 818.537,216.637 818.537,215.97 819.5,215.5C 820.773,216.257 820.773,216.923 819.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#e1b360",
    d: "M 897.5,218.5 C 898.833,219.167 898.833,219.167 897.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e0b25f",
    d: "M 899.5,218.5 C 900.833,219.167 900.833,219.167 899.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#94c5e8",
    d: "M 151.5,219.5 C 152.833,220.167 152.833,220.167 151.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feaf27",
    d: "M 591.5,221.5 C 669.167,221.333 746.834,221.5 824.5,222C 745.776,222.009 667.11,222.675 588.5,224C 585.272,225.563 583.105,228.063 582,231.5C 581.832,255.67 581.332,279.67 580.5,303.5C 580.333,279.164 580.5,254.831 581,230.5C 582.82,225.512 586.32,222.512 591.5,221.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#febf5c",
    d: "M 902.5,313.5 C 900.5,313.5 898.5,313.5 896.5,313.5C 874.66,313.169 852.994,313.503 831.5,314.5C 810.167,314.5 788.833,314.5 767.5,314.5C 708.832,314.667 650.166,314.5 591.5,314C 586.016,312.349 582.35,308.849 580.5,303.5C 581.332,279.67 581.832,255.67 582,231.5C 583.105,228.063 585.272,225.563 588.5,224C 667.11,222.675 745.776,222.009 824.5,222C 746.834,221.5 669.167,221.333 591.5,221.5C 599.984,220.507 608.651,220.174 617.5,220.5C 687.167,220.5 756.833,220.5 826.5,220.5C 827.397,219.402 828.23,219.402 829,220.5C 829.333,219.833 829.667,219.167 830,218.5C 831.849,219.561 833.849,220.227 836,220.5C 849.818,219.531 863.818,219.531 878,220.5C 879.452,218.175 881.119,218.175 883,220.5C 885.968,220.185 888.968,219.852 892,219.5C 902.363,218.837 908.697,223.503 911,233.5C 911.667,256.167 911.667,278.833 911,301.5C 909.893,306.766 907.06,310.766 902.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#216bfd",
    d: "M 410.5,223.5 C 410.082,224.222 409.416,224.722 408.5,225C 380.169,225.5 351.835,225.667 323.5,225.5C 282.167,225.5 240.833,225.5 199.5,225.5C 269.694,224.824 340.027,224.157 410.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e0b35e",
    d: "M 910.5,225.5 C 911.833,226.167 911.833,226.167 910.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1e261",
    d: "M 644.5,248.5 C 643.612,241.11 639.612,236.277 632.5,234C 626.461,232.804 620.795,233.638 615.5,236.5C 614.262,236.19 614.262,235.69 615.5,235C 630.325,228.048 640.491,232.215 646,247.5C 646.667,250.833 646.667,254.167 646,257.5C 645.819,254.305 645.319,251.305 644.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#140e6b",
    d: "M 644.5,248.5 C 644.5,251.5 644.5,254.5 644.5,257.5C 642.833,257.5 641.167,257.5 639.5,257.5C 640.069,252.223 639.235,247.223 637,242.5C 635.871,240.859 634.371,239.859 632.5,239.5C 624.011,236.07 618.011,238.737 614.5,247.5C 614.5,250.833 614.5,254.167 614.5,257.5C 612.833,257.5 611.167,257.5 609.5,257.5C 609.334,253.154 609.501,248.821 610,244.5C 611.129,241.206 612.962,238.54 615.5,236.5C 620.795,233.638 626.461,232.804 632.5,234C 639.612,236.277 643.612,241.11 644.5,248.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#18386b",
    d: "M 632.5,236.5 C 623.074,234.461 616.574,237.794 613,246.5C 611.67,259.833 611.003,259.833 611,246.5C 614.985,235.92 622.152,232.587 632.5,236.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#fdc25c",
    d: "M 632.5,239.5 C 632.062,239.435 631.728,239.601 631.5,240C 634,241.167 635.833,243 637,245.5C 638.225,250.085 638.725,254.752 638.5,259.5C 630.833,259.5 623.167,259.5 615.5,259.5C 615.817,255.298 615.483,251.298 614.5,247.5C 618.011,238.737 624.011,236.07 632.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#17356c",
    d: "M 632.5,236.5 C 637.287,237.156 640.454,239.822 642,244.5C 642.667,248.5 642.667,252.5 642,256.5C 642.35,248.001 639.184,241.334 632.5,236.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#94cefd",
    d: "M 189.5,206.5 C 187.892,215.624 191.225,221.957 199.5,225.5C 240.833,225.5 282.167,225.5 323.5,225.5C 321.727,226.892 319.727,228.059 317.5,229C 286.125,240.789 254.958,252.955 224,265.5C 226.488,323.118 236.988,379.118 255.5,433.5C 247.811,443.534 241.644,454.534 237,466.5C 236.107,467.711 235.274,467.711 234.5,466.5C 232.64,460.316 231.473,453.983 231,447.5C 230.647,435.431 229.647,423.431 228,411.5C 226.749,402.325 224.749,393.325 222,384.5C 218.046,373.94 210.546,369.773 199.5,372C 194.449,374.72 191.282,378.887 190,384.5C 190.07,401.204 191.07,417.87 193,434.5C 193.589,441.526 195.423,448.193 198.5,454.5C 196.655,455.395 195.322,454.728 194.5,452.5C 195.757,451.377 195.424,450.711 193.5,450.5C 194.463,449.637 194.463,448.97 193.5,448.5C 192.702,448.957 192.369,449.624 192.5,450.5C 191.508,450.672 190.842,450.338 190.5,449.5C 191.833,449.167 191.833,448.833 190.5,448.5C 192.787,445.661 192.454,442.995 189.5,440.5C 189.672,439.508 189.338,438.842 188.5,438.5C 188.02,435.557 187.02,432.89 185.5,430.5C 185.672,429.508 185.338,428.842 184.5,428.5C 183.602,423.466 181.935,418.799 179.5,414.5C 179.768,412.901 179.434,411.568 178.5,410.5C 176.869,403.289 174.869,396.289 172.5,389.5C 171.71,388.599 170.71,387.932 169.5,387.5C 170.108,386.2 170.775,384.867 171.5,383.5C 171.333,382.833 171.167,382.167 171,381.5C 170.851,384.279 170.017,384.779 168.5,383C 169.252,382.329 169.586,381.496 169.5,380.5C 170.097,380.265 170.43,379.765 170.5,379C 168.648,370.335 166.648,361.835 164.5,353.5C 164.795,351.265 164.461,349.265 163.5,347.5C 161.142,332.539 158.975,317.539 157,302.5C 156.667,302.833 156.333,303.167 156,303.5C 155.044,302.421 154.211,301.255 153.5,300C 154.744,299.544 155.577,300.044 156,301.5C 156.022,296.182 155.855,290.849 155.5,285.5C 154.448,285.649 153.448,285.483 152.5,285C 153.684,283.82 154.351,282.32 154.5,280.5C 154.006,273.998 153.339,267.665 152.5,261.5C 152.512,250.838 151.845,240.005 150.5,229C 151.912,223.171 155.245,218.838 160.5,216C 170.192,212.816 179.859,209.649 189.5,206.5 Z M 193.5,450.5 C 193.167,450.5 192.833,450.5 192.5,450.5C 192.369,449.624 192.702,448.957 193.5,448.5C 194.463,448.97 194.463,449.637 193.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#180e66",
    d: "M 711.5,257.5 C 712.29,258.401 713.29,259.068 714.5,259.5C 720.008,265.181 719.674,270.681 713.5,276C 701.584,278.077 697.418,273.244 701,261.5C 703.697,258.13 707.197,256.796 711.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8d75f",
    d: "M 711.5,257.5 C 707.197,256.796 703.697,258.13 701,261.5C 697.418,273.244 701.584,278.077 713.5,276C 719.674,270.681 720.008,265.181 714.5,259.5C 715.793,258.355 716.959,258.689 718,260.5C 722.429,270.561 719.262,276.561 708.5,278.5C 706.366,278.485 704.366,277.985 702.5,277C 697.895,273.368 695.562,268.535 695.5,262.5C 691.749,261.725 691.582,260.391 695,258.5C 696.011,259.337 697.178,259.67 698.5,259.5C 698.351,260.552 698.517,261.552 699,262.5C 700.167,260 702,258.167 704.5,257C 707.638,256.198 709.971,256.364 711.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#fde85e",
    d: "M 632.5,239.5 C 634.371,239.859 635.871,240.859 637,242.5C 639.235,247.223 640.069,252.223 639.5,257.5C 642.349,259.522 646.015,261.188 650.5,262.5C 649.391,262.443 648.391,262.11 647.5,261.5C 633.496,261.333 619.496,261.5 605.5,262C 603.574,262.422 602.574,263.589 602.5,265.5C 601.506,275.987 601.172,286.654 601.5,297.5C 600.341,286.341 600.174,275.008 601,263.5C 605.12,260.414 609.62,258.414 614.5,257.5C 614.5,254.167 614.5,250.833 614.5,247.5C 615.483,251.298 615.817,255.298 615.5,259.5C 623.167,259.5 630.833,259.5 638.5,259.5C 638.725,254.752 638.225,250.085 637,245.5C 635.833,243 634,241.167 631.5,240C 631.728,239.601 632.062,239.435 632.5,239.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3e363",
    d: "M 754.5,273.5 C 758.745,264.991 756.245,259.657 747,257.5C 737.968,259.563 735.302,264.896 739,273.5C 743.107,276.605 747.607,277.272 752.5,275.5C 753.738,275.81 753.738,276.31 752.5,277C 742.476,280.652 736.809,277.152 735.5,266.5C 738.336,257.193 744.336,254.36 753.5,258C 759.491,263.091 759.991,268.591 755,274.5C 754.601,274.272 754.435,273.938 754.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#23146b",
    d: "M 647.5,261.5 C 633.523,263.157 619.19,264.157 604.5,264.5C 603.356,275.453 603.189,286.453 604,297.5C 604.374,298.416 604.874,299.25 605.5,300C 619.833,300.667 634.167,300.667 648.5,300C 649.126,299.25 649.626,298.416 650,297.5C 650.667,286.833 650.667,276.167 650,265.5C 647.832,264.178 647.999,263.511 650.5,263.5C 650.5,264.167 650.833,264.5 651.5,264.5C 651.667,276.171 651.5,287.838 651,299.5C 650.097,300.701 648.931,301.535 647.5,302C 633.833,302.667 620.167,302.667 606.5,302C 605.069,301.535 603.903,300.701 603,299.5C 602.5,288.172 602.333,276.838 602.5,265.5C 602.574,263.589 603.574,262.422 605.5,262C 619.496,261.5 633.496,261.333 647.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a0865",
    d: "M 781.5,257.5 C 790.97,257.474 794.804,262.141 793,271.5C 792.167,273.667 790.667,275.167 788.5,276C 779.061,277.891 774.561,274.058 775,264.5C 776.694,261.642 778.861,259.309 781.5,257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0d2c68",
    d: "M 850.5,263.5 C 850.833,262.5 851.5,261.833 852.5,261.5C 852.435,261.938 852.601,262.272 853,262.5C 858.033,258.221 862.7,258.554 867,263.5C 868.717,272.116 865.217,275.949 856.5,275C 851.814,272.543 850.481,268.877 852.5,264C 851.906,263.536 851.239,263.369 850.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#120d65",
    d: "M 830.5,272.5 C 830.887,269.268 830.387,265.935 829,262.5C 823.967,258.221 819.3,258.554 815,263.5C 814.738,267.07 814.571,270.403 814.5,273.5C 811.794,268.725 812.128,264.059 815.5,259.5C 816.492,259.672 817.158,259.338 817.5,258.5C 828.75,256.75 833.083,261.416 830.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0d2d68",
    d: "M 647.5,261.5 C 648.391,262.11 649.391,262.443 650.5,262.5C 650.5,262.833 650.5,263.167 650.5,263.5C 647.999,263.511 647.832,264.178 650,265.5C 650.667,276.167 650.667,286.833 650,297.5C 649.626,298.416 649.126,299.25 648.5,300C 634.167,300.667 619.833,300.667 605.5,300C 604.874,299.25 604.374,298.416 604,297.5C 603.189,286.453 603.356,275.453 604.5,264.5C 619.19,264.157 633.523,263.157 647.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#0d2c6a",
    d: "M 705.5,259.5 C 714.778,258.376 718.278,262.376 716,271.5C 710.592,277.012 705.592,276.679 701,270.5C 699.776,265.626 701.276,261.959 705.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#0d2d6a",
    d: "M 780.5,259.5 C 788.614,258.121 792.447,261.454 792,269.5C 788.632,276.175 783.965,277.175 778,272.5C 775.458,267.438 776.292,263.105 780.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.014
    },
    fill: "#9bcdf5",
    d: "M 152.5,261.5 C 152.665,264.85 152.498,268.183 152,271.5C 151.192,267.973 151.359,264.64 152.5,261.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#100865",
    d: "M 754.5,273.5 C 753.5,273.833 752.833,274.5 752.5,275.5C 747.607,277.272 743.107,276.605 739,273.5C 735.302,264.896 737.968,259.563 747,257.5C 756.245,259.657 758.745,264.991 754.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d2c69",
    d: "M 743.5,259.5 C 752.778,258.376 756.278,262.376 754,271.5C 749.62,276.343 744.954,276.677 740,272.5C 737.676,267.167 738.843,262.833 743.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9bcaf2",
    d: "M 151.5,272.5 C 152.833,273.167 152.833,273.167 151.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5e662",
    d: "M 851.5,272.5 C 852.343,274.173 853.676,275.34 855.5,276C 867.759,277.075 871.592,271.908 867,260.5C 861.73,256.332 856.897,256.665 852.5,261.5C 851.5,261.833 850.833,262.5 850.5,263.5C 850.5,263.833 850.5,264.167 850.5,264.5C 849.698,265.952 849.198,267.618 849,269.5C 848.817,259.69 853.651,255.523 863.5,257C 874.13,263.899 874.13,270.899 863.5,278C 858.091,279.364 853.757,277.864 850.5,273.5C 850.624,272.893 850.957,272.56 851.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0c0865",
    d: "M 851.5,272.5 C 850.612,269.946 850.279,267.279 850.5,264.5C 850.5,264.167 850.5,263.833 850.5,263.5C 851.239,263.369 851.906,263.536 852.5,264C 850.481,268.877 851.814,272.543 856.5,275C 865.217,275.949 868.717,272.116 867,263.5C 862.7,258.554 858.033,258.221 853,262.5C 852.601,262.272 852.435,261.938 852.5,261.5C 856.897,256.665 861.73,256.332 867,260.5C 871.592,271.908 867.759,277.075 855.5,276C 853.676,275.34 852.343,274.173 851.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6e762",
    d: "M 815.5,259.5 C 812.128,264.059 811.794,268.725 814.5,273.5C 820.08,278.784 825.414,278.451 830.5,272.5C 833.083,261.416 828.75,256.75 817.5,258.5C 817.062,258.565 816.728,258.399 816.5,258C 825.694,254.43 831.361,257.43 833.5,267C 831.99,276.096 826.657,279.763 817.5,278C 815.714,277.215 814.214,276.049 813,274.5C 811.48,270.625 811.146,266.625 812,262.5C 812.759,260.937 813.926,259.937 815.5,259.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#122b67",
    d: "M 830.5,272.5 C 825.414,278.451 820.08,278.784 814.5,273.5C 814.571,270.403 814.738,267.07 815,263.5C 819.3,258.554 823.967,258.221 829,262.5C 830.387,265.935 830.887,269.268 830.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#9acaf3",
    d: "M 152.5,278.5 C 153.525,278.897 153.692,279.563 153,280.5C 152.536,279.906 152.369,279.239 152.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9acbf2",
    d: "M 153.5,287.5 C 154.525,287.897 154.692,288.563 154,289.5C 153.536,288.906 153.369,288.239 153.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#9accf4",
    d: "M 153.5,290.5 C 154.525,290.897 154.692,291.563 154,292.5C 153.536,291.906 153.369,291.239 153.5,290.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#99cdf3",
    d: "M 154.5,297.5 C 155.833,298.167 155.833,298.167 154.5,297.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#efde61",
    d: "M 601.5,297.5 C 601.172,286.654 601.506,275.987 602.5,265.5C 602.333,276.838 602.5,288.172 603,299.5C 603.903,300.701 605.069,301.535 606.5,302C 620.167,302.667 633.833,302.667 647.5,302C 648.931,301.535 650.097,300.701 651,299.5C 651.5,287.838 651.667,276.171 651.5,264.5C 651.81,263.262 652.31,263.262 653,264.5C 653.667,275.833 653.667,287.167 653,298.5C 652.215,300.286 651.049,301.786 649.5,303C 634.833,303.667 620.167,303.667 605.5,303C 602.785,302.125 601.452,300.292 601.5,297.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#f4f6f7",
    d: "M 625.5,272.5 C 629.562,272.012 631.895,273.678 632.5,277.5C 631.771,280.855 630.938,284.188 630,287.5C 628.522,290.993 626.522,291.326 624,288.5C 623.667,286.167 623.333,283.833 623,281.5C 619.348,277.219 620.181,274.219 625.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9cccf0",
    d: "M 156.5,312.5 C 157.833,313.167 157.833,313.167 156.5,312.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.213
    },
    fill: "#eac382",
    d: "M 831.5,314.5 C 852.994,313.503 874.66,313.169 896.5,313.5C 876.671,314.332 856.671,314.832 836.5,315C 838.5,315.333 840.5,315.667 842.5,316C 841.333,316.5 840.5,317.333 840,318.5C 838.657,317.786 837.324,318.12 836,319.5C 835.667,318.5 835.333,317.5 835,316.5C 834.802,318.382 834.302,320.048 833.5,321.5C 834.01,318.612 833.344,316.279 831.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e4b86d",
    d: "M 897.5,314.5 C 898.525,314.897 898.692,315.563 898,316.5C 897.536,315.906 897.369,315.239 897.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e1b56a",
    d: "M 902.5,313.5 C 903.773,314.077 903.773,314.743 902.5,315.5C 901.537,315.03 901.537,314.363 902.5,313.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#e3c48b",
    d: "M 843.5,316.5 C 845.035,315.212 846.701,315.212 848.5,316.5C 847.113,316.807 845.446,316.807 843.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#e7c583",
    d: "M 849.5,315.5 C 850.833,316.167 850.833,316.167 849.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#eac17b",
    d: "M 854.5,316.5 C 855.601,315.402 856.934,315.235 858.5,316C 857.207,316.49 855.873,316.657 854.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e9c078",
    d: "M 865.5,315.5 C 866.833,316.167 866.833,316.167 865.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.005
    },
    fill: "#eabf77",
    d: "M 871.5,316.5 C 870.127,316.657 868.793,316.49 867.5,316C 869.066,315.235 870.399,315.402 871.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e8bf74",
    d: "M 875.5,315.5 C 876.833,316.167 876.833,316.167 875.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e8be75",
    d: "M 878.5,316.5 C 879.077,315.227 879.743,315.227 880.5,316.5C 880.03,317.463 879.363,317.463 878.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#e8be71",
    d: "M 881.5,315.5 C 882.833,316.167 882.833,316.167 881.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#e8bd72",
    d: "M 883.5,315.5 C 884.833,316.167 884.833,316.167 883.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#e7bc6f",
    d: "M 889.5,315.5 C 890.833,316.167 890.833,316.167 889.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e5bb6e",
    d: "M 891.5,315.5 C 892.833,316.167 892.833,316.167 891.5,315.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#e7c07a",
    d: "M 863.5,316.5 C 864.833,317.167 864.833,317.167 863.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#e6bf78",
    d: "M 871.5,316.5 C 872.833,317.167 872.833,317.167 871.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9ccbf0",
    d: "M 157.5,318.5 C 158.833,319.167 158.833,319.167 157.5,318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9ad0f7",
    d: "M 159.5,333.5 C 160.525,333.897 160.692,334.563 160,335.5C 159.536,334.906 159.369,334.239 159.5,333.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#b5d0d6",
    d: "M 833.5,338.5 C 834.833,339.167 834.833,339.167 833.5,338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0c2b69",
    d: "M 723.5,414.5 C 719.933,414.133 716.6,413.133 713.5,411.5C 714.593,407.892 714.76,404.225 714,400.5C 713.184,399.177 712.017,398.511 710.5,398.5C 705.792,393.756 702.625,388.089 701,381.5C 689.669,386.148 677.836,388.148 665.5,387.5C 660.952,386.509 656.285,385.509 651.5,384.5C 646.577,383.082 641.91,381.082 637.5,378.5C 636.746,382.941 635.579,387.275 634,391.5C 630.562,395.441 626.729,398.775 622.5,401.5C 621.517,405.298 621.183,409.298 621.5,413.5C 618.455,413.508 615.455,413.841 612.5,414.5C 608.047,399.02 608.547,383.687 614,368.5C 615.927,363.572 619.427,360.406 624.5,359C 626.646,352.182 630.979,347.182 637.5,344C 649.86,337.996 662.86,335.996 676.5,338C 692.325,339.492 705.158,346.325 715,358.5C 724.186,376.143 727.019,394.81 723.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#9acdf5",
    d: "M 162.5,347.5 C 161.427,346.749 161.26,345.749 162,344.5C 162.483,345.448 162.649,346.448 162.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#9acdf8",
    d: "M 159.5,346.5 C 160.833,347.167 160.833,347.167 159.5,346.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.018
    },
    fill: "#98cbf6",
    d: "M 162.5,347.5 C 162.833,347.5 163.167,347.5 163.5,347.5C 163.167,352.833 162.833,352.833 162.5,347.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#98caf7",
    d: "M 159.5,348.5 C 160.833,349.167 160.833,349.167 159.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#99cef6",
    d: "M 164.5,353.5 C 163.833,354.167 163.833,354.167 164.5,353.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9acdf8",
    d: "M 164.5,358.5 C 165.833,359.167 165.833,359.167 164.5,358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#a8cee7",
    d: "M 830.5,360.5 C 831.573,361.251 831.74,362.251 831,363.5C 830.517,362.552 830.351,361.552 830.5,360.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a4cce9",
    d: "M 829.5,365.5 C 830.525,365.897 830.692,366.563 830,367.5C 829.536,366.906 829.369,366.239 829.5,365.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a5cfed",
    d: "M 830.5,372.5 C 831.833,373.167 831.833,373.167 830.5,372.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#96ccf6",
    d: "M 167.5,373.5 C 168.525,373.897 168.692,374.563 168,375.5C 167.536,374.906 167.369,374.239 167.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#4f95fe",
    d: "M 255.5,433.5 C 264.915,427.948 271.748,430.281 276,440.5C 276.234,453.235 274.068,465.568 269.5,477.5C 268.076,479.515 267.41,481.848 267.5,484.5C 266.503,484.47 265.836,484.97 265.5,486C 261.077,498.016 257.077,510.183 253.5,522.5C 253.833,523.167 254.167,523.833 254.5,524.5C 262.521,515.812 270.854,507.479 279.5,499.5C 282.869,497.485 286.202,495.485 289.5,493.5C 292.669,493.839 294.836,495.505 296,498.5C 296.667,502.833 296.667,507.167 296,511.5C 288.572,532.69 279.239,553.024 268,572.5C 266.682,575.406 266.348,578.406 267,581.5C 274.734,572.364 281.734,562.697 288,552.5C 291.167,549.333 294.333,546.167 297.5,543C 302.551,539.629 307.884,538.629 313.5,540C 315.894,541.952 317.394,544.452 318,547.5C 318.667,552.833 318.667,558.167 318,563.5C 313.693,577.776 307.526,591.11 299.5,603.5C 293.537,610.068 288.037,617.068 283,624.5C 282.366,627.555 282.532,630.555 283.5,633.5C 277.833,633.5 272.167,633.5 266.5,633.5C 265.56,629.94 263.893,626.94 261.5,624.5C 262.213,627.594 263.213,630.594 264.5,633.5C 251.421,633.814 238.421,633.48 225.5,632.5C 225.167,632.5 224.833,632.5 224.5,632.5C 224.167,632.5 223.833,632.5 223.5,632.5C 222.71,631.599 221.71,630.932 220.5,630.5C 218.544,629.508 216.544,628.508 214.5,627.5C 213.486,626.326 212.153,625.66 210.5,625.5C 207.76,623.44 204.76,621.774 201.5,620.5C 199.664,618.412 197.331,617.079 194.5,616.5C 194.027,615.094 193.027,614.427 191.5,614.5C 191.027,613.094 190.027,612.427 188.5,612.5C 188.5,611.833 188.167,611.5 187.5,611.5C 187.158,610.662 186.492,610.328 185.5,610.5C 185.5,609.833 185.167,609.5 184.5,609.5C 183.101,608.11 181.434,607.11 179.5,606.5C 179.027,605.094 178.027,604.427 176.5,604.5C 174.766,601.8 172.432,599.8 169.5,598.5C 169.5,597.833 169.167,597.5 168.5,597.5C 166.36,594.939 164.027,592.605 161.5,590.5C 154.756,576.366 159.423,569.366 175.5,569.5C 177.676,570.961 180.009,571.294 182.5,570.5C 183.696,570.846 183.696,571.346 182.5,572C 185.022,573.341 187.689,574.174 190.5,574.5C 191.172,575.267 192.005,575.934 193,576.5C 194.616,575.199 196.116,575.199 197.5,576.5C 194.833,576.833 194.833,577.167 197.5,577.5C 201.799,579.935 206.466,581.602 211.5,582.5C 213.137,583.38 214.97,584.046 217,584.5C 217.765,584.43 218.265,584.097 218.5,583.5C 219.833,581.833 219.833,580.167 218.5,578.5C 218.567,579.959 218.234,581.292 217.5,582.5C 216.534,579.555 215.2,576.888 213.5,574.5C 208.006,570.918 202.339,567.585 196.5,564.5C 196.167,563.167 195.833,563.167 195.5,564.5C 191.304,566.173 190.638,565.34 193.5,562C 192.154,560.331 190.487,559.164 188.5,558.5C 188.027,557.094 187.027,556.427 185.5,556.5C 183.051,553.444 180.051,551.111 176.5,549.5C 173.245,545.479 169.912,542.479 166.5,540.5C 166.167,539.5 165.5,538.833 164.5,538.5C 164.167,537.5 163.5,536.833 162.5,536.5C 160.806,534.139 158.806,532.139 156.5,530.5C 155.655,528.238 154.322,527.571 152.5,528.5C 151.209,527.527 151.209,526.527 152.5,525.5C 151.812,524.145 150.812,523.145 149.5,522.5C 148.66,520.147 147.326,518.147 145.5,516.5C 141.289,507.957 143.289,501.623 151.5,497.5C 155.151,497.746 158.651,497.746 162,497.5C 164.517,500.342 167.683,502.009 171.5,502.5C 172.659,504.25 174.326,505.25 176.5,505.5C 176.5,506.167 176.833,506.5 177.5,506.5C 177.842,507.338 178.508,507.672 179.5,507.5C 181.975,510.241 184.975,512.241 188.5,513.5C 188.842,514.338 189.508,514.672 190.5,514.5C 190.973,515.906 191.973,516.573 193.5,516.5C 193.973,517.906 194.973,518.573 196.5,518.5C 197.172,519.267 198.005,519.934 199,520.5C 200.292,519.209 201.458,519.209 202.5,520.5C 200.207,521.301 200.54,521.968 203.5,522.5C 204.833,523.833 206.167,523.833 207.5,522.5C 208.833,521.5 208.833,520.5 207.5,519.5C 207.34,517.847 206.674,516.514 205.5,515.5C 204.833,514.167 203.833,513.167 202.5,512.5C 202.5,511.833 202.167,511.5 201.5,511.5C 201.5,510.833 201.167,510.5 200.5,510.5C 196.5,505.833 192.167,501.5 187.5,497.5C 187.167,496.5 186.5,495.833 185.5,495.5C 184.876,493.246 183.543,491.579 181.5,490.5C 179.823,488.46 178.156,486.46 176.5,484.5C 175.445,481.445 173.445,479.445 170.5,478.5C 171.833,477.833 171.833,477.167 170.5,476.5C 169.189,473.865 167.522,471.531 165.5,469.5C 165.672,468.508 165.338,467.842 164.5,467.5C 161.327,461.485 158.994,455.152 157.5,448.5C 158.114,445.655 159.114,442.988 160.5,440.5C 166.767,436.554 173.101,436.554 179.5,440.5C 179.842,441.338 180.508,441.672 181.5,441.5C 182.5,444.167 183.5,444.167 184.5,441.5C 186.986,442.462 186.986,443.295 184.5,444C 185.244,445.039 186.244,445.539 187.5,445.5C 188.167,446.833 189.167,447.833 190.5,448.5C 190.5,448.833 190.5,449.167 190.5,449.5C 190.842,450.338 191.508,450.672 192.5,450.5C 192.833,450.5 193.167,450.5 193.5,450.5C 193.833,451.167 194.167,451.833 194.5,452.5C 195.322,454.728 196.655,455.395 198.5,454.5C 195.423,448.193 193.589,441.526 193,434.5C 191.07,417.87 190.07,401.204 190,384.5C 191.282,378.887 194.449,374.72 199.5,372C 210.546,369.773 218.046,373.94 222,384.5C 224.749,393.325 226.749,402.325 228,411.5C 229.647,423.431 230.647,435.431 231,447.5C 231.473,453.983 232.64,460.316 234.5,466.5C 235.274,467.711 236.107,467.711 237,466.5C 241.644,454.534 247.811,443.534 255.5,433.5 Z M 193.5,450.5 C 193.167,450.5 192.833,450.5 192.5,450.5C 192.369,449.624 192.702,448.957 193.5,448.5C 194.463,448.97 194.463,449.637 193.5,450.5 Z M 193.5,450.5 C 195.424,450.711 195.757,451.377 194.5,452.5C 194.167,451.833 193.833,451.167 193.5,450.5 Z M 217.5,462.5 C 218.85,465.952 219.35,469.619 219,473.5C 217.726,469.706 217.226,466.039 217.5,462.5 Z M 197.5,478.5 C 199.028,478.517 199.528,479.184 199,480.5C 198.283,479.956 197.783,479.289 197.5,478.5 Z M 223.5,493.5 C 221.933,489.065 220.6,484.565 219.5,480C 220,479.5 220.5,479 221,478.5C 222.218,482.966 223.385,487.466 224.5,492C 224.43,492.765 224.097,493.265 223.5,493.5 Z M 202.5,482.5 C 200.972,482.483 200.472,481.816 201,480.5C 201.717,481.044 202.217,481.711 202.5,482.5 Z M 206.5,486.5 C 205.711,486.217 205.044,485.717 204.5,485C 205.816,484.472 206.483,484.972 206.5,486.5 Z M 211.5,490.5 C 213.153,490.66 214.486,491.326 215.5,492.5C 213.678,493.429 212.345,492.762 211.5,490.5 Z M 215.5,492.5 C 216.5,492.833 217.167,493.5 217.5,494.5C 216.167,494.5 215.5,493.833 215.5,492.5 Z M 217.5,494.5 C 219.341,495.402 220.674,496.736 221.5,498.5C 219.167,498.167 217.833,496.833 217.5,494.5 Z M 223.5,494.5 C 225.225,494.843 225.725,495.843 225,497.5C 224.487,496.473 223.987,495.473 223.5,494.5 Z M 226.5,505.5 C 226.279,504.265 225.612,503.265 224.5,502.5C 224.533,501.011 225.033,499.678 226,498.5C 226.422,500.355 226.922,502.189 227.5,504C 227.43,504.765 227.097,505.265 226.5,505.5 Z M 237.5,503.5 C 237.598,505.553 236.931,507.22 235.5,508.5C 235.402,506.447 236.069,504.78 237.5,503.5 Z M 226.5,506.5 C 228.97,507.36 229.137,508.694 227,510.5C 227.355,509.041 227.189,507.707 226.5,506.5 Z M 233.5,532.5 C 231.523,525.946 229.523,519.279 227.5,512.5C 228.824,511.313 229.824,511.646 230.5,513.5C 230.291,514.086 229.957,514.586 229.5,515C 231.004,516.491 231.837,518.324 232,520.5C 232.642,524.491 233.142,528.491 233.5,532.5 Z M 191.5,513.5 C 192.167,514.167 192.833,514.833 193.5,515.5C 193.5,515.833 193.5,516.167 193.5,516.5C 191.973,516.573 190.973,515.906 190.5,514.5C 191.167,514.5 191.5,514.167 191.5,513.5 Z M 202.5,520.5 C 202.5,521.167 202.833,521.5 203.5,521.5C 203.5,521.833 203.5,522.167 203.5,522.5C 200.54,521.968 200.207,521.301 202.5,520.5 Z M 233.5,532.5 C 234.914,534.044 235.247,535.711 234.5,537.5C 233.548,535.955 233.215,534.288 233.5,532.5 Z M 195.5,539.5 C 197.423,539.795 199.09,540.628 200.5,542C 198.332,542.249 196.665,541.416 195.5,539.5 Z M 203.5,544.5 C 201.972,544.483 201.472,543.816 202,542.5C 202.717,543.044 203.217,543.711 203.5,544.5 Z M 239.5,554.5 C 237.493,551.235 236.327,547.569 236,543.5C 237.8,546.958 238.966,550.624 239.5,554.5 Z M 217.5,550.5 C 219.179,550.285 220.179,550.952 220.5,552.5C 218.973,552.573 217.973,551.906 217.5,550.5 Z M 228.5,554.5 C 226.712,554.785 225.045,554.452 223.5,553.5C 225.289,552.753 226.956,553.086 228.5,554.5 Z M 230.5,554.5 C 233.258,555.377 235.924,556.544 238.5,558C 236.217,558.291 234.05,557.791 232,556.5C 230.97,556.164 230.47,555.497 230.5,554.5 Z M 250.5,592.5 C 248.074,588.188 246.24,583.521 245,578.5C 244.333,576.833 244.333,575.167 245,573.5C 247.345,579.7 249.178,586.033 250.5,592.5 Z M 218.5,578.5 C 219.833,580.167 219.833,581.833 218.5,583.5C 218.5,582.833 218.167,582.5 217.5,582.5C 218.234,581.292 218.567,579.959 218.5,578.5 Z M 252.5,598.5 C 254.52,604.039 256.854,609.539 259.5,615C 259.167,615.167 258.833,615.333 258.5,615.5C 255.506,610.705 253.172,605.539 251.5,600C 252.056,599.617 252.389,599.117 252.5,598.5 Z M 211.5,602.5 C 214.336,602.202 214.836,602.869 213,604.5C 212.283,603.956 211.783,603.289 211.5,602.5 Z M 218.5,605.5 C 216.645,605.728 215.812,605.061 216,603.5C 216.995,604.066 217.828,604.733 218.5,605.5 Z M 221.5,606.5 C 222.675,606.281 223.675,606.614 224.5,607.5C 223.14,608.665 222.14,608.332 221.5,606.5 Z M 226.5,607.5 C 233.124,611.751 232.79,612.251 225.5,609C 226.056,608.617 226.389,608.117 226.5,607.5 Z M 240.5,613.5 C 242.415,613.216 244.081,613.549 245.5,614.5C 243.741,615.261 242.074,614.928 240.5,613.5 Z M 245.5,614.5 C 247.103,614.312 248.437,614.812 249.5,616C 247.648,616.773 246.314,616.273 245.5,614.5 Z M 261.5,624.5 C 263.893,626.94 265.56,629.94 266.5,633.5C 265.833,633.5 265.167,633.5 264.5,633.5C 263.213,630.594 262.213,627.594 261.5,624.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#a4d1f0",
    d: "M 828.5,373.5 C 829.525,373.897 829.692,374.563 829,375.5C 828.536,374.906 828.369,374.239 828.5,373.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#97cbf9",
    d: "M 169.5,380.5 C 168.833,379.167 168.833,379.167 169.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.005
    },
    fill: "#a5cfee",
    d: "M 827.5,379.5 C 828.598,380.601 828.765,381.934 828,383.5C 827.51,382.207 827.343,380.873 827.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#febaad",
    d: "M 651.5,384.5 C 656.285,385.509 660.952,386.509 665.5,387.5C 669.778,388.653 676.112,388.82 684.5,388C 689.391,387.069 694.224,385.902 699,384.5C 701.03,387.213 702.696,390.213 704,393.5C 705.777,395.79 707.944,397.457 710.5,398.5C 712.017,398.511 713.184,399.177 714,400.5C 714.76,404.225 714.593,407.892 713.5,411.5C 716.6,413.133 719.933,414.133 723.5,414.5C 729.314,425.558 726.147,432.558 714,435.5C 711.323,445.19 706.823,453.856 700.5,461.5C 700.167,462.5 699.5,463.167 698.5,463.5C 678.279,487.156 658.279,487.49 638.5,464.5C 637.599,463.71 636.932,462.71 636.5,461.5C 630.458,454.088 625.958,445.754 623,436.5C 620.455,435.478 617.955,434.312 615.5,433C 608.777,427.771 607.777,421.605 612.5,414.5C 615.455,413.841 618.455,413.508 621.5,413.5C 621.183,409.298 621.517,405.298 622.5,401.5C 622.669,416.152 623.169,416.152 624,401.5C 632.388,397.285 637.554,390.618 639.5,381.5C 643.445,383.837 647.445,384.837 651.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#f5e2c5",
    d: "M 710.5,398.5 C 707.944,397.457 705.777,395.79 704,393.5C 702.696,390.213 701.03,387.213 699,384.5C 694.224,385.902 689.391,387.069 684.5,388C 676.112,388.82 669.778,388.653 665.5,387.5C 677.836,388.148 689.669,386.148 701,381.5C 702.625,388.089 705.792,393.756 710.5,398.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#93caf8",
    d: "M 169.5,387.5 C 168.833,388.167 168.833,388.167 169.5,387.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#f4e1c6",
    d: "M 651.5,384.5 C 647.445,384.837 643.445,383.837 639.5,381.5C 637.554,390.618 632.388,397.285 624,401.5C 623.169,416.152 622.669,416.152 622.5,401.5C 626.729,398.775 630.562,395.441 634,391.5C 635.579,387.275 636.746,382.941 637.5,378.5C 641.91,381.082 646.577,383.082 651.5,384.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a3ceec",
    d: "M 826.5,386.5 C 827.525,386.897 827.692,387.563 827,388.5C 826.536,387.906 826.369,387.239 826.5,386.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#94c6f6",
    d: "M 168.5,388.5 C 167.833,389.167 167.833,389.167 168.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#92c9f8",
    d: "M 172.5,389.5 C 172.361,391.337 171.694,391.67 170.5,390.5C 170.957,389.702 171.624,389.369 172.5,389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#93c8f6",
    d: "M 172.5,395.5 C 173.525,395.897 173.692,396.563 173,397.5C 172.536,396.906 172.369,396.239 172.5,395.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#94c9f7",
    d: "M 173.5,398.5 C 174.833,399.167 174.833,399.167 173.5,398.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#8ec5f7",
    d: "M 175.5,405.5 C 176.525,405.897 176.692,406.563 176,407.5C 175.536,406.906 175.369,406.239 175.5,405.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9fcdef",
    d: "M 822.5,406.5 C 823.833,407.167 823.833,407.167 822.5,406.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#061168",
    d: "M 341.5,495.5 C 340.698,496.952 340.198,498.618 340,500.5C 339.389,496.318 340.056,492.318 342,488.5C 348.157,475.517 354.824,462.851 362,450.5C 366.462,441.116 369.296,431.283 370.5,421C 369.822,407.311 363.156,402.977 350.5,408C 342.375,415.802 336.208,424.969 332,435.5C 328.358,446.093 324.525,456.593 320.5,467C 319.563,467.692 318.897,467.525 318.5,466.5C 319.79,465.942 320.623,464.942 321,463.5C 324.345,451.13 328.679,439.13 334,427.5C 338.014,419.816 343.181,412.983 349.5,407C 357.342,402.763 364.175,403.93 370,410.5C 372.299,420.349 371.632,430.016 368,439.5C 360.543,455.748 352.543,471.748 344,487.5C 342.864,490.096 342.031,492.763 341.5,495.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#9fcef0",
    d: "M 822.5,408.5 C 823.573,409.251 823.74,410.251 823,411.5C 822.517,410.552 822.351,409.552 822.5,408.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#8dc3f7",
    d: "M 178.5,410.5 C 178.631,411.239 178.464,411.906 178,412.5C 177.308,411.563 177.475,410.897 178.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#8bc1f7",
    d: "M 179.5,414.5 C 178.833,415.167 178.833,415.167 179.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#9fcdf0",
    d: "M 821.5,414.5 C 822.525,414.897 822.692,415.563 822,416.5C 821.536,415.906 821.369,415.239 821.5,414.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#88c0f7",
    d: "M 179.5,417.5 C 178.833,416.167 178.833,416.167 179.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#89bef8",
    d: "M 179.5,417.5 C 180.833,418.167 180.833,418.167 179.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#94cefd",
    d: "M 767.5,314.5 C 788.833,314.5 810.167,314.5 831.5,314.5C 833.344,316.279 834.01,318.612 833.5,321.5C 833.16,331.892 832.16,342.225 830.5,352.5C 831.021,354.524 831.188,356.524 831,358.5C 830.667,358.167 830.333,357.833 830,357.5C 827.498,373.846 824.998,390.18 822.5,406.5C 819.391,418.619 816.724,430.952 814.5,443.5C 813.232,445.905 812.565,448.572 812.5,451.5C 810.054,458.946 808.054,466.613 806.5,474.5C 803.665,483.012 800.999,491.678 798.5,500.5C 795.333,508.659 792.333,516.992 789.5,525.5C 789.846,526.696 790.346,526.696 791,525.5C 791.78,527.387 791.613,529.054 790.5,530.5C 790.672,529.508 790.338,528.842 789.5,528.5C 789.5,527.833 789.167,527.5 788.5,527.5C 783.418,514.008 776.251,501.675 767,490.5C 757.555,481.698 746.722,475.364 734.5,471.5C 734.196,470.85 733.863,470.183 733.5,469.5C 750.37,419.023 761.703,367.357 767.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#a0cff2",
    d: "M 820.5,418.5 C 821.833,419.167 821.833,419.167 820.5,418.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#88bff8",
    d: "M 180.5,420.5 C 179.833,419.167 179.833,419.167 180.5,420.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#86bdf8",
    d: "M 180.5,420.5 C 181.773,421.077 181.773,421.743 180.5,422.5C 179.537,422.03 179.537,421.363 180.5,420.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9ecded",
    d: "M 819.5,424.5 C 820.833,425.167 820.833,425.167 819.5,424.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9eceee",
    d: "M 818.5,427.5 C 819.833,428.167 819.833,428.167 818.5,427.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#81bbf6",
    d: "M 184.5,428.5 C 184.328,429.492 184.662,430.158 185.5,430.5C 184.698,431.885 184.031,431.718 183.5,430C 183.57,429.235 183.903,428.735 184.5,428.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9eccec",
    d: "M 817.5,432.5 C 818.833,433.167 818.833,433.167 817.5,432.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#7ab3fa",
    d: "M 183.5,434.5 C 184.833,435.167 184.833,435.167 183.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#79b4f9",
    d: "M 185.5,434.5 C 186.525,434.897 186.692,435.563 186,436.5C 185.536,435.906 185.369,435.239 185.5,434.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#74abf4",
    d: "M 169.5,436.5 C 170.601,435.402 171.934,435.235 173.5,436C 172.207,436.49 170.873,436.657 169.5,436.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9dccef",
    d: "M 816.5,436.5 C 817.833,437.167 817.833,437.167 816.5,436.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#75b3fa",
    d: "M 187.5,438.5 C 186.833,437.167 186.833,437.167 187.5,438.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#79b4f8",
    d: "M 187.5,438.5 C 187.833,438.5 188.167,438.5 188.5,438.5C 188.315,439.17 187.981,439.17 187.5,438.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#71a9f3",
    d: "M 160.5,440.5 C 159.833,439.167 159.833,439.167 160.5,440.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#6dacfa",
    d: "M 179.5,440.5 C 180.386,439.224 181.386,439.224 182.5,440.5C 182.376,441.107 182.043,441.44 181.5,441.5C 181.158,440.662 180.492,440.328 179.5,440.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#71aefa",
    d: "M 184.5,439.5 C 185.833,440.167 185.833,440.167 184.5,439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6fadfb",
    d: "M 184.5,440.5 C 184.5,440.833 184.5,441.167 184.5,441.5C 183.83,441.019 183.83,440.685 184.5,440.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#71adf8",
    d: "M 189.5,440.5 C 188.833,441.167 188.833,441.167 189.5,440.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a156c",
    d: "M 317.5,465.5 C 317.565,465.938 317.399,466.272 317,466.5C 314.985,457.452 311.985,448.785 308,440.5C 298.701,435.142 292.701,437.809 290,448.5C 288.327,457.244 287.16,465.91 286.5,474.5C 286.13,466.097 286.63,457.764 288,449.5C 288.759,446.215 290.092,443.215 292,440.5C 298,433.833 304,433.833 310,440.5C 313.816,448.448 316.316,456.781 317.5,465.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6faef9",
    d: "M 188.5,441.5 C 187.833,442.167 187.833,442.167 188.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6eacf9",
    d: "M 187.5,445.5 C 187.843,443.775 188.843,443.275 190.5,444C 189.473,444.513 188.473,445.013 187.5,445.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#9ccdf4",
    d: "M 814.5,443.5 C 815.613,444.946 815.78,446.613 815,448.5C 814.506,446.866 814.34,445.199 814.5,443.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6da5ef",
    d: "M 155.5,448.5 C 156.525,448.897 156.692,449.563 156,450.5C 155.536,449.906 155.369,449.239 155.5,448.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9dcff3",
    d: "M 813.5,450.5 C 814.833,451.167 814.833,451.167 813.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9accf4",
    d: "M 812.5,451.5 C 812.833,451.5 813.167,451.5 813.5,451.5C 813.315,452.17 812.981,452.17 812.5,451.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#9ccef6",
    d: "M 812.5,453.5 C 813.525,453.897 813.692,454.563 813,455.5C 812.536,454.906 812.369,454.239 812.5,453.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9ccdf3",
    d: "M 811.5,456.5 C 812.833,457.167 812.833,457.167 811.5,456.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9accf3",
    d: "M 812.5,459.5 C 813.833,460.167 813.833,460.167 812.5,459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#66a0f6",
    d: "M 160.5,462.5 C 161.833,463.167 161.833,463.167 160.5,462.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9bcbf0",
    d: "M 809.5,464.5 C 810.833,465.167 810.833,465.167 809.5,464.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#65a2f9",
    d: "M 163.5,467.5 C 162.833,466.167 162.833,466.167 163.5,467.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#66a0f5",
    d: "M 163.5,467.5 C 163.833,467.5 164.167,467.5 164.5,467.5C 164.315,468.17 163.981,468.17 163.5,467.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#64a0f6",
    d: "M 165.5,469.5 C 165.631,470.239 165.464,470.906 165,471.5C 164.308,470.563 164.475,469.897 165.5,469.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#5196fe",
    d: "M 636.5,461.5 C 636.932,462.71 637.599,463.71 638.5,464.5C 636.443,476.852 638.277,488.519 644,499.5C 654.14,513.085 666.973,516.252 682.5,509C 691.303,503.185 696.47,495.018 698,484.5C 698.5,477.508 698.666,470.508 698.5,463.5C 699.5,463.167 700.167,462.5 700.5,461.5C 712.135,463.823 723.468,467.156 734.5,471.5C 746.722,475.364 757.555,481.698 767,490.5C 776.251,501.675 783.418,514.008 788.5,527.5C 789.167,527.5 789.5,527.833 789.5,528.5C 789.328,529.492 789.662,530.158 790.5,530.5C 790.421,531.93 790.754,533.264 791.5,534.5C 792.993,535.141 793.993,536.141 794.5,537.5C 793.637,536.537 792.97,536.537 792.5,537.5C 792.942,538.739 793.609,539.739 794.5,540.5C 798.429,552.405 804.429,563.071 812.5,572.5C 813.786,575.117 815.453,577.45 817.5,579.5C 817.833,580.5 818.5,581.167 819.5,581.5C 819.947,584.524 820.78,584.857 822,582.5C 823.495,584.11 823.661,585.776 822.5,587.5C 823.696,589.145 824.696,590.811 825.5,592.5C 825.369,593.239 825.536,593.906 826,594.5C 826.671,593.748 827.504,593.414 828.5,593.5C 828.657,594.873 828.49,596.207 828,597.5C 827.444,595.405 826.944,595.238 826.5,597C 826.06,599.671 826.727,602.171 828.5,604.5C 826.174,613.134 823.841,621.801 821.5,630.5C 818.796,636.267 816.462,642.267 814.5,648.5C 811.519,654.461 808.519,660.461 805.5,666.5C 804.094,666.973 803.427,667.973 803.5,669.5C 794.62,683.118 782.287,692.118 766.5,696.5C 766.5,696.167 766.5,695.833 766.5,695.5C 767.664,664.003 767.831,632.336 767,600.5C 766.722,599.584 766.222,598.918 765.5,598.5C 764.415,594.246 761.748,591.413 757.5,590C 698.5,589.333 639.5,589.333 580.5,590C 579.328,590.419 578.328,591.085 577.5,592C 577.728,592.399 578.062,592.565 578.5,592.5C 577.833,593.833 576.833,594.833 575.5,595.5C 575.19,594.262 574.69,594.262 574,595.5C 573.333,596.833 572.667,598.167 572,599.5C 571.5,631.165 571.333,662.832 571.5,694.5C 564.079,691.955 557.079,688.622 550.5,684.5C 545.127,679.294 540.294,673.627 536,667.5C 535.31,666.262 534.81,666.262 534.5,667.5C 534.167,667.5 533.833,667.5 533.5,667.5C 522.115,649.712 514.281,630.379 510,609.5C 508.927,601.983 509.594,594.65 512,587.5C 517.696,578.325 523.53,569.325 529.5,560.5C 540.357,539.263 551.024,517.93 561.5,496.5C 567.144,487.695 574.81,481.195 584.5,477C 601.388,470.279 618.721,465.112 636.5,461.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#efa799",
    d: "M 698.5,463.5 C 698.666,470.508 698.5,477.508 698,484.5C 696.47,495.018 691.303,503.185 682.5,509C 666.973,516.252 654.14,513.085 644,499.5C 638.277,488.519 636.443,476.852 638.5,464.5C 658.279,487.49 678.279,487.156 698.5,463.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#99cbf4",
    d: "M 806.5,474.5 C 807.833,475.167 807.833,475.167 806.5,474.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#99cbf6",
    d: "M 806.5,476.5 C 807.833,477.167 807.833,477.167 806.5,476.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#64a3f9",
    d: "M 170.5,476.5 C 170.5,477.167 170.5,477.833 170.5,478.5C 169.167,477.833 169.167,477.167 170.5,476.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#98cbf4",
    d: "M 805.5,478.5 C 806.833,479.167 806.833,479.167 805.5,478.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8ecafa",
    d: "M 269.5,477.5 C 273.604,483.525 277.604,489.691 281.5,496C 280.725,497.23 279.725,497.563 278.5,497C 276.38,494.591 274.38,492.091 272.5,489.5C 273.167,489.167 273.833,488.833 274.5,488.5C 272.433,487.866 270.6,486.866 269,485.5C 268.601,485.728 268.435,486.062 268.5,486.5C 267.662,486.158 267.328,485.492 267.5,484.5C 267.41,481.848 268.076,479.515 269.5,477.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#99c8f4",
    d: "M 806.5,482.5 C 807.833,483.167 807.833,483.167 806.5,482.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#65a2f8",
    d: "M 176.5,484.5 C 177.087,485.767 177.087,486.767 176.5,487.5C 175.224,486.386 175.224,485.386 176.5,484.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#97cbf8",
    d: "M 803.5,486.5 C 804.833,487.167 804.833,487.167 803.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#66a2fa",
    d: "M 181.5,490.5 C 180.833,491.167 180.833,491.167 181.5,490.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#96c9f3",
    d: "M 801.5,493.5 C 802.833,494.167 802.833,494.167 801.5,493.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#0b3796",
    d: "M 267.5,484.5 C 267.328,485.492 267.662,486.158 268.5,486.5C 271.821,491.152 275.487,495.485 279.5,499.5C 270.854,507.479 262.521,515.812 254.5,524.5C 254.167,523.833 253.833,523.167 253.5,522.5C 257.077,510.183 261.077,498.016 265.5,486C 265.836,484.97 266.503,484.47 267.5,484.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#69a1ef",
    d: "M 149.5,496.5 C 148.833,495.167 148.833,495.167 149.5,496.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.011
    },
    fill: "#64a2f5",
    d: "M 151.5,496.5 C 153.288,495.378 155.288,495.211 157.5,496C 155.527,496.495 153.527,496.662 151.5,496.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#66a3f5",
    d: "M 158.5,495.5 C 159.833,496.167 159.833,496.167 158.5,495.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#61a0fc",
    d: "M 165.5,495.5 C 166.833,496.167 166.833,496.167 165.5,495.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#63a2fa",
    d: "M 185.5,495.5 C 184.833,496.167 184.833,496.167 185.5,495.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6a9fe9",
    d: "M 143.5,496.5 C 144.833,497.167 144.833,497.167 143.5,496.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#68a0ed",
    d: "M 149.5,496.5 C 150.167,496.5 150.833,496.5 151.5,496.5C 151.5,496.833 151.5,497.167 151.5,497.5C 150.508,497.672 149.842,497.338 149.5,496.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.009
    },
    fill: "#61a0fb",
    d: "M 165.5,498.5 C 163.972,498.483 163.472,497.816 164,496.5C 164.717,497.044 165.217,497.711 165.5,498.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#61a0fc",
    d: "M 187.5,497.5 C 186.833,498.167 186.833,498.167 187.5,497.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#63a2fc",
    d: "M 165.5,498.5 C 166.833,499.167 166.833,499.167 165.5,498.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#69a0e9",
    d: "M 143.5,499.5 C 144.833,500.167 144.833,500.167 143.5,499.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#61a0fa",
    d: "M 171.5,501.5 C 170.833,500.167 170.833,500.167 171.5,501.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#629ffb",
    d: "M 171.5,501.5 C 172.833,502.167 172.833,502.167 171.5,501.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#619ffb",
    d: "M 188.5,501.5 C 189.833,502.167 189.833,502.167 188.5,501.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#95c8f6",
    d: "M 798.5,500.5 C 799.573,501.251 799.74,502.251 799,503.5C 798.517,502.552 798.351,501.552 798.5,500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#62a3fb",
    d: "M 176.5,504.5 C 175.833,503.167 175.833,503.167 176.5,504.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#61a0fa",
    d: "M 177.5,506.5 C 176.833,506.5 176.5,506.167 176.5,505.5C 176.5,505.167 176.5,504.833 176.5,504.5C 177.117,504.389 177.617,504.056 178,503.5C 178.74,504.749 178.573,505.749 177.5,506.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#63a1fd",
    d: "M 191.5,504.5 C 192.833,505.167 192.833,505.167 191.5,504.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#93c6f8",
    d: "M 797.5,504.5 C 798.833,505.167 798.833,505.167 797.5,504.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#63a0fb",
    d: "M 181.5,505.5 C 182.833,506.167 182.833,506.167 181.5,505.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#65a3fa",
    d: "M 179.5,506.5 C 180.833,507.167 180.833,507.167 179.5,506.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#63a3fd",
    d: "M 195.5,507.5 C 196.833,508.167 196.833,508.167 195.5,507.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#62a2fd",
    d: "M 196.5,511.5 C 196.897,510.475 197.563,510.308 198.5,511C 197.906,511.464 197.239,511.631 196.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#90c7f8",
    d: "M 795.5,510.5 C 796.833,511.167 796.833,511.167 795.5,510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#61a1fd",
    d: "M 196.5,511.5 C 195.833,512.167 195.833,512.167 196.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#63a4fa",
    d: "M 200.5,510.5 C 201.167,510.5 201.5,510.833 201.5,511.5C 201.5,511.833 201.5,512.167 201.5,512.5C 199.576,512.289 199.243,511.623 200.5,510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#61a2fa",
    d: "M 188.5,513.5 C 187.632,511.108 188.299,510.941 190.5,513C 189.906,513.464 189.239,513.631 188.5,513.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#62a1fd",
    d: "M 191.5,513.5 C 191.56,512.957 191.893,512.624 192.5,512.5C 193.386,513.325 193.719,514.325 193.5,515.5C 192.833,514.833 192.167,514.167 191.5,513.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#64a2fa",
    d: "M 201.5,512.5 C 201.833,512.5 202.167,512.5 202.5,512.5C 202.315,513.17 201.981,513.17 201.5,512.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#8dc3f4",
    d: "M 795.5,512.5 C 796.833,513.167 796.833,513.167 795.5,512.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#64a2fd",
    d: "M 196.5,515.5 C 197.833,516.167 197.833,516.167 196.5,515.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#63a2fc",
    d: "M 201.5,515.5 C 202.833,516.167 202.833,516.167 201.5,515.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#65a2fa",
    d: "M 205.5,515.5 C 204.833,516.167 204.833,516.167 205.5,515.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#679eed",
    d: "M 145.5,516.5 C 144.833,517.167 144.833,517.167 145.5,516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#63a3fc",
    d: "M 196.5,516.5 C 196.5,516.833 196.5,517.167 196.5,517.5C 195.83,517.019 195.83,516.685 196.5,516.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#64a3fc",
    d: "M 196.5,517.5 C 197.833,518.167 197.833,518.167 196.5,517.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#66a6fc",
    d: "M 207.5,519.5 C 207.5,520.5 207.5,521.5 207.5,522.5C 206.167,522.5 204.833,522.5 203.5,522.5C 203.5,522.167 203.5,521.833 203.5,521.5C 205.199,521.473 206.533,520.806 207.5,519.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#68a1ee",
    d: "M 149.5,522.5 C 148.833,523.167 148.833,523.167 149.5,522.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#659df0",
    d: "M 152.5,528.5 C 151.833,529.167 151.833,529.167 152.5,528.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#649ff1",
    d: "M 156.5,530.5 C 155.833,531.167 155.833,531.167 156.5,530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#65a1f5",
    d: "M 162.5,536.5 C 161.833,537.167 161.833,537.167 162.5,536.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6da9f7",
    d: "M 794.5,537.5 C 795.833,538.167 795.833,538.167 794.5,537.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#649ff4",
    d: "M 164.5,538.5 C 163.833,539.167 163.833,539.167 164.5,538.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#639ff4",
    d: "M 161.5,539.5 C 162.833,540.167 162.833,540.167 161.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#6ca7f6",
    d: "M 794.5,539.5 C 795.833,540.167 795.833,540.167 794.5,539.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#659ff4",
    d: "M 166.5,540.5 C 165.833,541.167 165.833,541.167 166.5,540.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3379fe",
    d: "M 561.5,496.5 C 551.024,517.93 540.357,539.263 529.5,560.5C 537.952,542.651 546.119,524.651 554,506.5C 555.979,502.7 558.479,499.366 561.5,496.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#6ca7f7",
    d: "M 795.5,541.5 C 796.833,542.167 796.833,542.167 795.5,541.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#68a5f8",
    d: "M 796.5,543.5 C 797.833,544.167 797.833,544.167 796.5,543.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#68a6f8",
    d: "M 798.5,544.5 C 799.833,545.167 799.833,545.167 798.5,544.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#68a4f7",
    d: "M 798.5,545.5 C 798.631,546.239 798.464,546.906 798,547.5C 797.308,546.563 797.475,545.897 798.5,545.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#68a7f8",
    d: "M 798.5,548.5 C 799.833,549.167 799.833,549.167 798.5,548.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#63a1fc",
    d: "M 171.5,549.5 C 172.833,550.167 172.833,550.167 171.5,549.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#62a2f9",
    d: "M 176.5,549.5 C 177.614,551.353 176.948,551.853 174.5,551C 175.044,550.283 175.711,549.783 176.5,549.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#68a1f8",
    d: "M 800.5,552.5 C 801.833,553.167 801.833,553.167 800.5,552.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#65a1f9",
    d: "M 181.5,554.5 C 180.833,553.167 180.833,553.167 181.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#66a2fa",
    d: "M 181.5,554.5 C 182.833,555.167 182.833,555.167 181.5,554.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#63a2fb",
    d: "M 185.5,556.5 C 185.103,557.525 184.437,557.692 183.5,557C 184.094,556.536 184.761,556.369 185.5,556.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#64a2f9",
    d: "M 188.5,558.5 C 187.833,559.167 187.833,559.167 188.5,558.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#65a1f8",
    d: "M 804.5,560.5 C 804.897,559.475 805.563,559.308 806.5,560C 805.906,560.464 805.239,560.631 804.5,560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#63a1f8",
    d: "M 806.5,562.5 C 807.833,563.167 807.833,563.167 806.5,562.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#61a1fd",
    d: "M 195.5,564.5 C 195.833,564.5 196.167,564.5 196.5,564.5C 196.5,564.833 196.5,565.167 196.5,565.5C 196.167,565.167 195.833,564.833 195.5,564.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#63a1fb",
    d: "M 196.5,565.5 C 197.833,566.167 197.833,566.167 196.5,565.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.005
    },
    fill: "#64a3f9",
    d: "M 167.5,568.5 C 168.946,567.387 170.613,567.22 172.5,568C 170.866,568.494 169.199,568.66 167.5,568.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.005
    },
    fill: "#62a1fc",
    d: "M 175.5,569.5 C 176.14,567.668 177.14,567.335 178.5,568.5C 177.675,569.386 176.675,569.719 175.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#64a2fe",
    d: "M 181.5,567.5 C 182.833,568.167 182.833,568.167 181.5,567.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#6aa1f2",
    d: "M 159.5,568.5 C 160.833,569.167 160.833,569.167 159.5,568.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#68a2f3",
    d: "M 164.5,569.5 C 164.897,568.475 165.563,568.308 166.5,569C 165.906,569.464 165.239,569.631 164.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6aa2f2",
    d: "M 159.5,570.5 C 160.833,571.167 160.833,571.167 159.5,570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#65a4fe",
    d: "M 184.5,570.5 C 185.833,571.167 185.833,571.167 184.5,570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5f9ef5",
    d: "M 813.5,572.5 C 812.833,571.167 812.833,571.167 813.5,572.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#619df5",
    d: "M 813.5,572.5 C 814.167,572.5 814.5,572.833 814.5,573.5C 814.167,573.167 813.833,572.833 813.5,572.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#67a5fe",
    d: "M 190.5,573.5 C 191.833,574.167 191.833,574.167 190.5,573.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#66a6fe",
    d: "M 208.5,574.5 C 207.833,573.167 207.833,573.167 208.5,574.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#619ef3",
    d: "M 814.5,573.5 C 815.833,574.167 815.833,574.167 814.5,573.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#64a3fd",
    d: "M 208.5,574.5 C 209.833,575.167 209.833,575.167 208.5,574.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#66a4f9",
    d: "M 213.5,574.5 C 213.103,575.525 212.437,575.692 211.5,575C 212.094,574.536 212.761,574.369 213.5,574.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#63a3fc",
    d: "M 197.5,577.5 C 197.5,577.167 197.5,576.833 197.5,576.5C 198.648,575.105 199.648,575.272 200.5,577C 199.552,577.483 198.552,577.649 197.5,577.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#629ff3",
    d: "M 816.5,575.5 C 817.833,576.167 817.833,576.167 816.5,575.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6ba0ec",
    d: "M 156.5,577.5 C 157.833,578.167 157.833,578.167 156.5,577.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#64a5ff",
    d: "M 205.5,578.5 C 206.833,579.167 206.833,579.167 205.5,578.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#609df2",
    d: "M 817.5,579.5 C 817.897,578.475 818.563,578.308 819.5,579C 818.906,579.464 818.239,579.631 817.5,579.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#639df0",
    d: "M 820.5,578.5 C 821.833,579.167 821.833,579.167 820.5,578.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#609cef",
    d: "M 822.5,578.5 C 823.833,579.167 823.833,579.167 822.5,578.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#629ef2",
    d: "M 819.5,580.5 C 820.833,581.167 820.833,581.167 819.5,580.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#68a7fc",
    d: "M 211.5,581.5 C 212.833,582.167 212.833,582.167 211.5,581.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f64fd",
    d: "M 765.5,598.5 C 763.3,595.142 760.3,592.642 756.5,591C 698.167,590.333 639.833,590.333 581.5,591C 580.473,591.513 579.473,592.013 578.5,592.5C 578.062,592.565 577.728,592.399 577.5,592C 578.328,591.085 579.328,590.419 580.5,590C 639.5,589.333 698.5,589.333 757.5,590C 761.748,591.413 764.415,594.246 765.5,598.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#64a2ed",
    d: "M 161.5,590.5 C 160.833,591.167 160.833,591.167 161.5,590.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#f6fbfd",
    d: "M 765.5,598.5 C 766.478,630.802 766.812,663.135 766.5,695.5C 766.5,695.833 766.5,696.167 766.5,696.5C 766.158,697.338 765.492,697.672 764.5,697.5C 764.651,666.137 764.485,634.471 764,602.5C 763.728,597.562 761.228,594.396 756.5,593C 698.167,592.333 639.833,592.333 581.5,593C 578.667,594.5 576.5,596.667 575,599.5C 574.104,636.516 574.438,673.516 576,710.5C 577.765,713.473 580.265,715.64 583.5,717C 583.272,717.399 582.938,717.565 582.5,717.5C 579.326,716.99 576.992,715.323 575.5,712.5C 573.667,707.392 573.001,702.058 573.5,696.5C 573.831,674.327 573.497,652.327 572.5,630.5C 572.334,620.494 572.5,610.494 573,600.5C 573.847,598.807 574.68,597.14 575.5,595.5C 576.833,594.833 577.833,593.833 578.5,592.5C 579.473,592.013 580.473,591.513 581.5,591C 639.833,590.333 698.167,590.333 756.5,591C 760.3,592.642 763.3,595.142 765.5,598.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#619cef",
    d: "M 825.5,591.5 C 826.833,592.167 826.833,592.167 825.5,591.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#83c2fb",
    d: "M 328.5,589.5 C 330.335,590.122 331.502,591.456 332,593.5C 332.273,595.101 332.773,596.601 333.5,598C 327.287,601.347 320.62,603.18 313.5,603.5C 313.549,600.901 314.549,598.734 316.5,597C 320.407,594.241 324.407,591.741 328.5,589.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#639cea",
    d: "M 828.5,592.5 C 829.833,593.167 829.833,593.167 828.5,592.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#dbf0fe",
    d: "M 764.5,697.5 C 756.95,701.108 749.283,704.442 741.5,707.5C 731.152,711.228 720.818,715.061 710.5,719C 667.665,719.205 624.998,718.705 582.5,717.5C 582.938,717.565 583.272,717.399 583.5,717C 580.265,715.64 577.765,713.473 576,710.5C 574.438,673.516 574.104,636.516 575,599.5C 576.5,596.667 578.667,594.5 581.5,593C 639.833,592.333 698.167,592.333 756.5,593C 761.228,594.396 763.728,597.562 764,602.5C 764.485,634.471 764.651,666.137 764.5,697.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6aa3f2",
    d: "M 164.5,595.5 C 163.833,594.167 163.833,594.167 164.5,595.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6299e7",
    d: "M 830.5,594.5 C 831.833,595.167 831.833,595.167 830.5,594.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6ca4f3",
    d: "M 164.5,595.5 C 165.833,596.167 165.833,596.167 164.5,595.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6ea6f4",
    d: "M 165.5,597.5 C 166.833,598.167 166.833,598.167 165.5,597.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#0c3b95",
    d: "M 341.5,495.5 C 341.5,497.167 341.5,498.833 341.5,500.5C 353.336,494.202 365.336,488.035 377.5,482C 381.167,481.333 384.833,481.333 388.5,482C 392.758,483.521 395.091,486.521 395.5,491C 394.006,497.985 390.673,503.985 385.5,509C 370.719,520.446 355.385,531.113 339.5,541C 337.333,543.167 335.167,545.333 333,547.5C 331.836,550.567 332.836,552.233 336,552.5C 344.228,549.868 352.395,547.035 360.5,544C 364.833,543.333 369.167,543.333 373.5,544C 375.677,545.497 377.01,547.497 377.5,550C 375.769,557.449 371.769,563.449 365.5,568C 351.474,577.016 336.807,585.016 321.5,592C 318.217,593.561 315.383,595.727 313,598.5C 312.333,600.5 312.333,602.5 313,604.5C 313.893,605.081 314.893,605.415 316,605.5C 327.893,601.801 339.726,597.968 351.5,594C 358.735,592.073 364.235,594.24 368,600.5C 367.439,608.929 363.606,615.595 356.5,620.5C 356.44,619.957 356.107,619.624 355.5,619.5C 348.789,624.7 341.456,628.866 333.5,632C 317.156,632.833 300.823,632.666 284.5,631.5C 283.218,628.273 283.718,625.273 286,622.5C 291.133,616.547 295.633,610.214 299.5,603.5C 307.526,591.11 313.693,577.776 318,563.5C 318.667,558.167 318.667,552.833 318,547.5C 317.394,544.452 315.894,541.952 313.5,540C 307.884,538.629 302.551,539.629 297.5,543C 294.333,546.167 291.167,549.333 288,552.5C 281.734,562.697 274.734,572.364 267,581.5C 266.348,578.406 266.682,575.406 268,572.5C 279.239,553.024 288.572,532.69 296,511.5C 296.667,507.167 296.667,502.833 296,498.5C 294.836,495.505 292.669,493.839 289.5,493.5C 287.85,487.284 286.85,480.951 286.5,474.5C 287.16,465.91 288.327,457.244 290,448.5C 292.701,437.809 298.701,435.142 308,440.5C 311.985,448.785 314.985,457.452 317,466.5C 317.399,466.272 317.565,465.938 317.5,465.5C 318.167,465.5 318.5,465.833 318.5,466.5C 318.897,467.525 319.563,467.692 320.5,467C 324.525,456.593 328.358,446.093 332,435.5C 336.208,424.969 342.375,415.802 350.5,408C 363.156,402.977 369.822,407.311 370.5,421C 369.296,431.283 366.462,441.116 362,450.5C 354.824,462.851 348.157,475.517 342,488.5C 340.056,492.318 339.389,496.318 340,500.5C 340.198,498.618 340.698,496.952 341.5,495.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.286
    },
    fill: "#6798dd",
    d: "M 329.5,569.5 C 329.53,570.497 329.03,571.164 328,571.5C 323.958,573.457 319.791,574.624 315.5,575C 320.023,572.866 324.689,571.033 329.5,569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#3a64b6",
    d: "M 314.5,517.5 C 313.366,522.544 311.7,527.377 309.5,532C 309.833,532.5 310.167,533 310.5,533.5C 314.354,531.742 318.021,529.742 321.5,527.5C 317.564,530.915 313.397,534.248 309,537.5C 308.702,533.316 308.536,528.983 308.5,524.5C 309.154,522.885 309.654,521.218 310,519.5C 310.308,520.308 310.808,520.975 311.5,521.5C 312.057,519.668 313.057,518.335 314.5,517.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#6c9bdc",
    d: "M 306.5,486.5 C 303.057,482.975 301.89,478.642 303,473.5C 304.106,477.868 305.272,482.201 306.5,486.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.094
    },
    fill: "#6497da",
    d: "M 302.5,468.5 C 302.167,468.5 301.833,468.5 301.5,468.5C 300.404,464.587 300.238,460.587 301,456.5C 302.156,460.418 302.656,464.418 302.5,468.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#6ba4f3",
    d: "M 168.5,597.5 C 169.167,597.5 169.5,597.833 169.5,598.5C 169.44,599.043 169.107,599.376 168.5,599.5C 167.227,598.743 167.227,598.077 168.5,597.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#6299e9",
    d: "M 828.5,599.5 C 830.76,600.238 830.927,601.238 829,602.5C 828.517,601.552 828.351,600.552 828.5,599.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5f98ec",
    d: "M 828.5,603.5 C 829.833,604.167 829.833,604.167 828.5,603.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#70abf5",
    d: "M 176.5,604.5 C 176.5,604.833 176.5,605.167 176.5,605.5C 175.83,605.019 175.83,604.685 176.5,604.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#70aaf6",
    d: "M 176.5,605.5 C 177.833,606.167 177.833,606.167 176.5,605.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1167fe",
    d: "M 765.5,598.5 C 766.222,598.918 766.722,599.584 767,600.5C 767.831,632.336 767.664,664.003 766.5,695.5C 766.812,663.135 766.478,630.802 765.5,598.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#6fa9f7",
    d: "M 179.5,606.5 C 178.833,607.167 178.833,607.167 179.5,606.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.007
    },
    fill: "#5e98eb",
    d: "M 827.5,608.5 C 828.573,609.251 828.74,610.251 828,611.5C 827.517,610.552 827.351,609.552 827.5,608.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#75adf7",
    d: "M 184.5,609.5 C 185.167,609.5 185.5,609.833 185.5,610.5C 185.5,610.833 185.5,611.167 185.5,611.5C 184.167,611.833 184.167,612.167 185.5,612.5C 184.528,613.751 183.861,613.418 183.5,611.5C 183.543,610.584 183.876,609.917 184.5,609.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#77acf6",
    d: "M 185.5,612.5 C 185.5,612.167 185.5,611.833 185.5,611.5C 186.167,611.5 186.833,611.5 187.5,611.5C 188.167,611.5 188.5,611.833 188.5,612.5C 187.472,615.098 186.472,615.098 185.5,612.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#79aff9",
    d: "M 183.5,614.5 C 184.833,615.167 184.833,615.167 183.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#7ab0f6",
    d: "M 191.5,614.5 C 190.833,615.167 190.833,615.167 191.5,614.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#83b4f8",
    d: "M 194.5,616.5 C 194.5,616.833 194.5,617.167 194.5,617.5C 191.833,617.167 191.833,616.833 194.5,616.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#85b3f9",
    d: "M 194.5,617.5 C 195.833,618.167 195.833,618.167 194.5,617.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#84b7f8",
    d: "M 196.5,618.5 C 197.833,619.167 197.833,619.167 196.5,618.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5d98eb",
    d: "M 825.5,618.5 C 826.833,619.167 826.833,619.167 825.5,618.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#88b9f7",
    d: "M 193.5,619.5 C 194.833,620.167 194.833,620.167 193.5,619.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#87baf8",
    d: "M 196.5,619.5 C 195.833,620.167 195.833,620.167 196.5,619.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#81b6fa",
    d: "M 201.5,620.5 C 202.895,621.648 202.728,622.648 201,623.5C 198.86,621.947 199.027,620.947 201.5,620.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#8dbbf7",
    d: "M 194.5,622.5 C 193.833,621.167 193.833,621.167 194.5,622.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#92bff5",
    d: "M 191.5,622.5 C 192.833,623.167 192.833,623.167 191.5,622.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#8ebcf7",
    d: "M 194.5,622.5 C 195.833,623.167 195.833,623.167 194.5,622.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#96c3f9",
    d: "M 210.5,625.5 C 210.989,628.826 210.322,628.993 208.5,626C 209.094,625.536 209.761,625.369 210.5,625.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#96c5f7",
    d: "M 214.5,627.5 C 214.5,627.833 214.5,628.167 214.5,628.5C 213.83,628.019 213.83,627.685 214.5,627.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9fc8f6",
    d: "M 214.5,628.5 C 215.833,629.167 215.833,629.167 214.5,628.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#1267fd",
    d: "M 575.5,595.5 C 574.68,597.14 573.847,598.807 573,600.5C 572.5,610.494 572.334,620.494 572.5,630.5C 572.831,652.007 572.497,673.34 571.5,694.5C 571.333,662.832 571.5,631.165 572,599.5C 572.667,598.167 573.333,596.833 574,595.5C 574.69,594.262 575.19,594.262 575.5,595.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a9cff7",
    d: "M 210.5,630.5 C 211.833,631.167 211.833,631.167 210.5,630.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a1cbf8",
    d: "M 216.5,631.5 C 216.897,630.475 217.563,630.308 218.5,631C 217.906,631.464 217.239,631.631 216.5,631.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#98c6f5",
    d: "M 220.5,630.5 C 219.833,631.167 219.833,631.167 220.5,630.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#badbf8",
    d: "M 199.5,632.5 C 199.897,631.475 200.563,631.308 201.5,632C 200.906,632.464 200.239,632.631 199.5,632.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#5b98ed",
    d: "M 821.5,630.5 C 822.525,630.897 822.692,631.563 822,632.5C 821.536,631.906 821.369,631.239 821.5,630.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#000b5c",
    d: "M 299.5,603.5 C 295.633,610.214 291.133,616.547 286,622.5C 283.718,625.273 283.218,628.273 284.5,631.5C 300.823,632.666 317.156,632.833 333.5,632C 341.456,628.866 348.789,624.7 355.5,619.5C 356.107,619.624 356.44,619.957 356.5,620.5C 350.463,624.513 344.463,628.513 338.5,632.5C 320.201,633.461 301.868,633.794 283.5,633.5C 282.532,630.555 282.366,627.555 283,624.5C 288.037,617.068 293.537,610.068 299.5,603.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#bdddfa",
    d: "M 193.5,633.5 C 194.525,633.897 194.692,634.563 194,635.5C 193.536,634.906 193.369,634.239 193.5,633.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#ddf0fe",
    d: "M 223.5,632.5 C 223.833,632.5 224.167,632.5 224.5,632.5C 224.833,633.833 225.167,633.833 225.5,632.5C 238.421,633.48 251.421,633.814 264.5,633.5C 265.167,633.5 265.833,633.5 266.5,633.5C 272.167,633.5 277.833,633.5 283.5,633.5C 301.868,633.794 320.201,633.461 338.5,632.5C 349.918,632.418 355.418,638.084 355,649.5C 354.116,656.049 350.616,660.549 344.5,663C 297.665,663.167 250.998,663.667 204.5,664.5C 201.933,663.525 199.267,662.858 196.5,662.5C 195.564,661.026 194.23,660.026 192.5,659.5C 187.014,650.404 188.347,642.237 196.5,635C 199.101,634.08 201.768,633.413 204.5,633C 211.134,632.579 217.467,632.412 223.5,632.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#91ccfd",
    d: "M 664.5,634.5 C 684.323,633.825 692.157,643.158 688,662.5C 680.744,673.586 671.244,676.086 659.5,670C 647.625,658.95 647.625,647.95 659.5,637C 661.315,636.243 662.981,635.41 664.5,634.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5994ec",
    d: "M 819.5,637.5 C 820.833,638.167 820.833,638.167 819.5,637.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#c6e2f8",
    d: "M 189.5,639.5 C 190.833,640.167 190.833,640.167 189.5,639.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#c4e1f7",
    d: "M 189.5,640.5 C 189.631,641.239 189.464,641.906 189,642.5C 188.308,641.563 188.475,640.897 189.5,640.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5992e9",
    d: "M 818.5,640.5 C 819.833,641.167 819.833,641.167 818.5,640.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#5790e6",
    d: "M 816.5,644.5 C 817.833,645.167 817.833,645.167 816.5,644.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#5490e7",
    d: "M 814.5,648.5 C 815.525,648.897 815.692,649.563 815,650.5C 814.536,649.906 814.369,649.239 814.5,648.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#518be0",
    d: "M 812.5,653.5 C 813.525,653.897 813.692,654.563 813,655.5C 812.536,654.906 812.369,654.239 812.5,653.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#cde7fa",
    d: "M 192.5,659.5 C 191.833,660.167 191.833,660.167 192.5,659.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#cce6fa",
    d: "M 192.5,662.5 C 193.833,663.167 193.833,663.167 192.5,662.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#cfe6f8",
    d: "M 196.5,662.5 C 196.103,663.525 195.437,663.692 194.5,663C 195.094,662.536 195.761,662.369 196.5,662.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#d0e9fb",
    d: "M 201.5,664.5 C 202.833,665.167 202.833,665.167 201.5,664.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#cfe7fa",
    d: "M 204.5,665.5 C 203.833,666.167 203.833,666.167 204.5,665.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#487dce",
    d: "M 805.5,666.5 C 806.833,667.167 806.833,667.167 805.5,666.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#acd6fc",
    d: "M 204.5,665.5 C 204.5,665.167 204.5,664.833 204.5,664.5C 249.5,664.5 294.5,664.5 339.5,664.5C 338.228,678.076 336.895,691.409 335.5,704.5C 333.171,723.799 331.171,743.132 329.5,762.5C 328.302,767.67 327.302,773.003 326.5,778.5C 324.259,782.749 321.592,786.749 318.5,790.5C 314.638,792.262 310.972,794.262 307.5,796.5C 305.436,796.687 303.436,797.187 301.5,798C 302.833,798.333 304.167,798.667 305.5,799C 297.855,798.878 290.189,799.545 282.5,801C 276.509,801.499 270.509,801.666 264.5,801.5C 279.646,799.984 290.813,792.317 298,778.5C 300.636,770.322 302.636,761.989 304,753.5C 306.9,726.831 309.734,700.164 312.5,673.5C 277.833,673.5 243.167,673.5 208.5,673.5C 207.722,670.461 206.388,667.794 204.5,665.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#cde7fb",
    d: "M 205.5,670.5 C 204.833,669.167 204.833,669.167 205.5,670.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#cce6fb",
    d: "M 205.5,670.5 C 206.833,671.167 206.833,671.167 205.5,670.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#81b8fd",
    d: "M 572.5,630.5 C 573.497,652.327 573.831,674.327 573.5,696.5C 564.79,694.313 557.123,690.313 550.5,684.5C 557.079,688.622 564.079,691.955 571.5,694.5C 572.497,673.34 572.831,652.007 572.5,630.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#2152a2",
    d: "M 829.5,671.5 C 830.833,672.167 830.833,672.167 829.5,671.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#2457a6",
    d: "M 832.5,672.5 C 832.897,671.475 833.563,671.308 834.5,672C 833.906,672.464 833.239,672.631 832.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2354a3",
    d: "M 839.5,672.5 C 840.833,673.167 840.833,673.167 839.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2051a0",
    d: "M 845.5,673.5 C 846.833,674.167 846.833,674.167 845.5,673.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#24509d",
    d: "M 849.5,674.5 C 850.833,675.167 850.833,675.167 849.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#dcf1fe",
    d: "M 208.5,673.5 C 243.167,673.5 277.833,673.5 312.5,673.5C 309.734,700.164 306.9,726.831 304,753.5C 302.636,761.989 300.636,770.322 298,778.5C 290.813,792.317 279.646,799.984 264.5,801.5C 261.5,801.5 258.5,801.5 255.5,801.5C 251.262,799.319 246.762,798.652 242,799.5C 238.937,799.065 238.77,798.232 241.5,797C 239.975,795.991 238.308,795.491 236.5,795.5C 235.738,793.738 234.404,792.738 232.5,792.5C 231.833,791.167 230.833,790.167 229.5,789.5C 227.759,787.023 226.259,784.356 225,781.5C 224.444,783.595 223.944,783.762 223.5,782C 220.354,758.152 216.688,734.319 212.5,710.5C 212.672,709.508 212.338,708.842 211.5,708.5C 212.966,706.365 212.8,704.365 211,702.5C 210.667,702.833 210.333,703.167 210,703.5C 209.503,701.19 209.337,698.857 209.5,696.5C 210.833,694.167 210.833,691.833 209.5,689.5C 209.81,686.287 209.477,683.287 208.5,680.5C 208.15,678.374 208.15,676.041 208.5,673.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#73befb",
    d: "M 550.5,684.5 C 543.808,680.14 538.474,674.474 534.5,667.5C 534.81,666.262 535.31,666.262 536,667.5C 540.294,673.627 545.127,679.294 550.5,684.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d4edfc",
    d: "M 208.5,680.5 C 207.833,681.167 207.833,681.167 208.5,680.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#053ba0",
    d: "M 566.5,714.5 C 567.167,714.5 567.5,714.833 567.5,715.5C 567.797,720.828 568.131,725.661 568.5,730C 566.314,730.604 566.148,731.77 568,733.5C 570.552,730.806 571.719,731.473 571.5,735.5C 570.178,735.67 569.011,735.337 568,734.5C 567.824,737.026 568.99,738.859 571.5,740C 570.874,740.75 570.374,741.584 570,742.5C 569.692,741.692 569.192,741.025 568.5,740.5C 567.772,742.193 566.772,743.693 565.5,745C 565.833,745.333 566.167,745.667 566.5,746C 565.692,746.308 565.025,746.808 564.5,747.5C 564.938,748.506 565.604,748.506 566.5,747.5C 567.578,750.043 566.578,751.376 563.5,751.5C 561.864,750.696 560.364,749.696 559,748.5C 558.383,749.449 558.549,750.282 559.5,751C 557.296,752.446 554.629,752.946 551.5,752.5C 552.274,753.711 553.107,753.711 554,752.5C 554.333,753.167 554.667,753.833 555,754.5C 556.388,753.446 557.888,753.28 559.5,754C 557.671,754.273 556.171,755.107 555,756.5C 552.968,754.232 551.635,754.898 551,758.5C 549.667,757.833 548.667,756.833 548,755.5C 546.933,756.191 545.766,756.691 544.5,757C 546.271,757.535 546.604,758.369 545.5,759.5C 544.186,758.687 543.019,757.687 542,756.5C 540.092,759.332 539.259,758.999 539.5,755.5C 538.178,755.67 537.011,755.337 536,754.5C 535.383,755.449 535.549,756.282 536.5,757C 535.333,757.5 534.5,758.333 534,759.5C 529.985,759.303 525.818,759.303 521.5,759.5C 521.344,755.865 520.178,755.532 518,758.5C 516.601,757.773 515.101,757.273 513.5,757C 514.696,756.346 514.696,755.846 513.5,755.5C 511.851,755.075 510.017,755.075 508,755.5C 507.833,755.167 507.667,754.833 507.5,754.5C 509.078,753.702 510.744,753.202 512.5,753C 511.975,752.308 511.308,751.808 510.5,751.5C 508.833,751.5 507.167,751.5 505.5,751.5C 505.167,750.833 504.833,750.167 504.5,749.5C 503.264,750.246 501.93,750.579 500.5,750.5C 500.657,749.127 500.49,747.793 500,746.5C 499.667,746.833 499.333,747.167 499,747.5C 498.632,746.09 497.799,745.09 496.5,744.5C 496.26,745.837 495.76,747.503 495,749.5C 493.991,747.975 493.491,746.308 493.5,744.5C 492.022,744.762 490.689,744.429 489.5,743.5C 488.197,741.029 486.363,739.029 484,737.5C 482.739,737.759 481.739,738.426 481,739.5C 480.333,736.833 479.667,736.833 479,739.5C 477.65,736.328 475.483,733.162 472.5,730C 474.396,728.935 474.563,728.102 473,727.5C 471.848,729.512 470.682,729.678 469.5,728C 469.833,727.667 470.167,727.333 470.5,727C 469.376,726.751 468.376,726.251 467.5,725.5C 467.938,724.494 468.604,724.494 469.5,725.5C 471.911,723.681 472.078,721.681 470,719.5C 469.667,719.833 469.333,720.167 469,720.5C 468.727,718.899 468.227,717.399 467.5,716C 468.253,714.513 469.086,714.346 470,715.5C 470.743,713.559 470.576,711.726 469.5,710C 470.449,709.383 471.282,709.549 472,710.5C 472.333,709.167 472.667,707.833 473,706.5C 473.333,706.833 473.667,707.167 474,707.5C 476.966,705.067 476.8,703.567 473.5,703C 474.126,702.25 474.626,701.416 475,700.5C 475.333,700.833 475.667,701.167 476,701.5C 476.707,699.919 477.54,698.419 478.5,697C 478.167,696.667 477.833,696.333 477.5,696C 478.996,695.493 480.163,695.993 481,697.5C 481.617,696.551 481.451,695.718 480.5,695C 482.108,694.342 483.275,694.842 484,696.5C 484.576,693.208 486.243,692.208 489,693.5C 490.63,692.287 492.464,691.454 494.5,691C 495.13,689.108 496.13,687.441 497.5,686C 501.132,686.311 504.632,686.478 508,686.5C 509.872,685.932 511.705,685.265 513.5,684.5C 514.192,685.025 514.692,685.692 515,686.5C 515.667,685.167 516.667,684.167 518,683.5C 517.923,684.738 518.089,685.738 518.5,686.5C 519.251,685.624 519.751,684.624 520,683.5C 520.354,685.807 521.354,686.141 523,684.5C 524.845,685.756 526.845,686.756 529,687.5C 529.772,687.355 530.439,687.022 531,686.5C 531.49,687.793 531.657,689.127 531.5,690.5C 534.292,690.452 536.125,691.785 537,694.5C 538.566,695.061 539.899,694.394 541,692.5C 541.833,694 543,695.167 544.5,696C 544.167,696.333 543.833,696.667 543.5,697C 547.87,698.521 551.037,701.355 553,705.5C 553.869,700.492 554.536,700.825 555,706.5C 555.333,705.833 555.667,705.167 556,704.5C 556.71,705.973 557.876,706.64 559.5,706.5C 558.959,711.628 561.292,714.295 566.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#d7effd",
    d: "M 207.5,685.5 C 208.525,685.897 208.692,686.563 208,687.5C 207.536,686.906 207.369,686.239 207.5,685.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#d7eefe",
    d: "M 209.5,689.5 C 209.5,691.833 209.5,694.167 209.5,696.5C 208.711,696.217 208.044,695.717 207.5,695C 208.109,693.052 208.776,691.218 209.5,689.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#053ba0",
    d: "M 597.5,780.5 C 597.5,779.833 597.167,779.5 596.5,779.5C 597.189,778.226 598.023,778.226 599,779.5C 599.167,779 599.333,778.5 599.5,778C 599.14,776.348 598.807,774.682 598.5,773C 600.93,770.555 603.596,768.555 606.5,767C 606.167,766.667 605.833,766.333 605.5,766C 607.053,764.903 608.386,763.57 609.5,762C 615.951,758.691 622.451,755.525 629,752.5C 630.107,753.712 630.607,753.379 630.5,751.5C 632.472,752.517 633.805,751.85 634.5,749.5C 637.1,750.359 639.6,750.692 642,750.5C 644.2,748.169 646.2,748.169 648,750.5C 649.614,749.977 651.114,748.644 652.5,746.5C 653.192,747.025 653.692,747.692 654,748.5C 654.845,745.815 656.678,744.149 659.5,743.5C 661.851,743.387 664.184,744.053 666.5,745.5C 666.119,743.058 666.786,742.391 668.5,743.5C 670.098,741.027 671.598,741.027 673,743.5C 673.283,740.258 674.117,739.924 675.5,742.5C 676.478,742.023 677.311,741.357 678,740.5C 680.184,742.871 682.35,742.704 684.5,740C 683.304,739.346 683.304,738.846 684.5,738.5C 685.192,739.025 685.692,739.692 686,740.5C 687.25,739.427 688.584,739.427 690,740.5C 691.261,740.241 692.261,739.574 693,738.5C 693.667,741.167 694.333,741.167 695,738.5C 697.058,739.109 697.891,740.109 697.5,741.5C 698.451,740.674 699.451,740.508 700.5,741C 699.304,741.654 699.304,742.154 700.5,742.5C 701.215,740.222 702.382,738.889 704,738.5C 705.229,740.947 706.729,741.113 708.5,739C 707.327,735.89 707.827,735.723 710,738.5C 710.317,736.699 710.984,736.366 712,737.5C 713.314,736.687 714.481,735.687 715.5,734.5C 718.035,735.503 720.202,734.837 722,732.5C 722.333,733.167 722.667,733.833 723,734.5C 725.056,732.681 727.223,732.015 729.5,732.5C 732.163,730.379 734.996,729.713 738,730.5C 738.439,727.701 739.772,726.701 742,727.5C 742.317,725.699 742.984,725.366 744,726.5C 745.399,725.773 746.899,725.273 748.5,725C 747.112,724.111 747.278,723.611 749,723.5C 749.772,723.645 750.439,723.978 751,724.5C 751.249,723.376 751.749,722.376 752.5,721.5C 752.911,722.262 753.077,723.262 753,724.5C 758.932,720.393 765.098,717.393 771.5,715.5C 773.102,716.55 773.935,715.883 774,713.5C 774.414,713.957 774.914,714.291 775.5,714.5C 777.22,712.869 779.22,711.703 781.5,711C 781.167,710.667 780.833,710.333 780.5,710C 781.931,709.535 783.097,708.701 784,707.5C 784.333,707.833 784.667,708.167 785,708.5C 785.333,707.5 785.667,706.5 786,705.5C 787.011,706.337 788.178,706.67 789.5,706.5C 789.351,705.448 789.517,704.448 790,703.5C 791.049,704.517 792.216,704.684 793.5,704C 794.787,702.59 795.954,701.09 797,699.5C 797.667,700.833 798.333,700.833 799,699.5C 799.333,698.167 799.667,696.833 800,695.5C 800.414,695.957 800.914,696.291 801.5,696.5C 801.833,695.833 802.167,695.167 802.5,694.5C 803.086,694.709 803.586,695.043 804,695.5C 807.438,693.678 810.771,692.345 814,691.5C 815,692.5 816,693.5 817,694.5C 817.333,693.5 817.667,692.5 818,691.5C 818.333,691.833 818.667,692.167 819,692.5C 819.689,691.643 820.522,690.977 821.5,690.5C 822.874,691.711 824.374,692.711 826,693.5C 827.098,692.616 827.598,691.616 827.5,690.5C 827.974,692.272 829.14,693.939 831,695.5C 832.321,692.591 834.488,691.425 837.5,692C 837.5,693 837.5,694 837.5,695C 838.449,695.617 839.282,695.451 840,694.5C 841.033,697.033 842.867,698.699 845.5,699.5C 845.313,698.183 845.98,696.85 847.5,695.5C 850.555,696.678 853.555,698.511 856.5,701C 855.833,701.667 855.167,702.333 854.5,703C 854.952,704.612 856.285,705.612 858.5,706C 856.003,708.26 856.67,709.593 860.5,710C 858.668,710.748 857.001,711.748 855.5,713C 856.167,713.333 856.833,713.667 857.5,714C 856.446,715.388 856.28,716.888 857,718.5C 857.743,716.355 858.576,716.189 859.5,718C 857.717,721.568 856.05,725.068 854.5,728.5C 853.808,727.975 853.308,727.308 853,726.5C 850.954,727.911 849.121,729.577 847.5,731.5C 846.808,730.975 846.308,730.308 846,729.5C 845.426,732.321 844.092,734.654 842,736.5C 841.333,735.167 840.667,735.167 840,736.5C 840.444,740.064 838.611,741.898 834.5,742C 835.5,742.333 836.5,742.667 837.5,743C 835.567,743.251 833.734,743.751 832,744.5C 831.667,743.5 831.333,742.5 831,741.5C 830.138,743.087 829.471,744.754 829,746.5C 828.026,744.122 827.359,744.456 827,747.5C 826.586,747.043 826.086,746.709 825.5,746.5C 824.335,747.491 823.168,748.491 822,749.5C 821.055,749.095 820.388,748.428 820,747.5C 819.667,748.5 819.333,749.5 819,750.5C 816.901,751.466 815.068,752.8 813.5,754.5C 813.331,753.603 812.998,752.603 812.5,751.5C 810.519,752.105 810.185,753.105 811.5,754.5C 810.278,756.978 808.278,757.978 805.5,757.5C 805.349,760.718 804.516,761.051 803,758.5C 802.085,759.328 801.419,760.328 801,761.5C 799.951,760.483 798.784,760.316 797.5,761C 798.604,762.131 798.271,762.965 796.5,763.5C 795.808,762.975 795.308,762.308 795,761.5C 795.094,764.501 793.761,766.501 791,767.5C 789,767.5 787,767.5 785,767.5C 783.488,768.257 782.154,769.257 781,770.5C 779.667,770.5 778.333,770.5 777,770.5C 775.667,773.167 774.333,775.833 773,778.5C 772.626,777.584 772.126,776.75 771.5,776C 773.007,775.163 773.507,773.996 773,772.5C 772.333,771.167 771.667,771.167 771,772.5C 770.517,773.448 770.351,774.448 770.5,775.5C 768.876,775.36 767.71,776.027 767,777.5C 766.581,776.328 765.915,775.328 765,774.5C 764.383,775.449 764.549,776.282 765.5,777C 763.699,777.317 763.366,777.984 764.5,779C 761.315,777.766 759.315,778.932 758.5,782.5C 758.709,783.086 759.043,783.586 759.5,784C 758.256,784.456 757.423,783.956 757,782.5C 756.667,783.167 756.333,783.833 756,784.5C 754.951,783.483 753.784,783.316 752.5,784C 750.457,785.811 748.957,787.978 748,790.5C 748,789.167 748,787.833 748,786.5C 745.957,788.208 744.29,790.208 743,792.5C 742.113,789.292 740.447,789.292 738,792.5C 737.667,792.167 737.333,791.833 737,791.5C 734.42,793.253 731.587,794.253 728.5,794.5C 728.421,795.93 728.754,797.264 729.5,798.5C 728.5,799.333 727.5,800.167 726.5,801C 727.654,801.914 727.487,802.747 726,803.5C 725.667,802.833 725.333,802.167 725,801.5C 723.384,802.545 721.717,803.545 720,804.5C 718.809,802.153 716.976,801.32 714.5,802C 715.624,802.249 716.624,802.749 717.5,803.5C 716.167,804.5 714.833,805.5 713.5,806.5C 712.808,805.975 712.308,805.308 712,804.5C 711.581,805.672 710.915,806.672 710,807.5C 707.476,806.692 704.643,806.359 701.5,806.5C 700.304,806.846 700.304,807.346 701.5,808C 700.101,808.595 698.768,808.428 697.5,807.5C 694.188,809.631 690.855,810.964 687.5,811.5C 686.522,811.023 685.689,810.357 685,809.5C 683.667,810.833 682.333,812.167 681,813.5C 680,813.167 679,812.833 678,812.5C 674.896,815.287 671.396,815.954 667.5,814.5C 665.386,815.034 663.552,816.034 662,817.5C 660.221,814.724 659.221,815.057 659,818.5C 655.988,815.75 653.321,816.083 651,819.5C 646.966,820.768 642.966,820.768 639,819.5C 637.921,821.394 636.587,821.727 635,820.5C 634.667,821.167 634.333,821.833 634,822.5C 632.933,821.809 631.766,821.309 630.5,821C 631.711,820.107 631.711,819.274 630.5,818.5C 629.167,819.5 627.833,820.5 626.5,821.5C 625.833,821.167 625.167,820.833 624.5,820.5C 623.702,822.078 623.202,823.744 623,825.5C 618.089,811.013 611.589,797.346 603.5,784.5C 601.736,782.722 599.736,781.389 597.5,780.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#053898",
    d: "M 566.5,714.5 C 561.292,714.295 558.959,711.628 559.5,706.5C 557.876,706.64 556.71,705.973 556,704.5C 555.667,705.167 555.333,705.833 555,706.5C 554.536,700.825 553.869,700.492 553,705.5C 551.037,701.355 547.87,698.521 543.5,697C 543.833,696.667 544.167,696.333 544.5,696C 543,695.167 541.833,694 541,692.5C 539.899,694.394 538.566,695.061 537,694.5C 536.125,691.785 534.292,690.452 531.5,690.5C 531.657,689.127 531.49,687.793 531,686.5C 530.439,687.022 529.772,687.355 529,687.5C 526.845,686.756 524.845,685.756 523,684.5C 521.354,686.141 520.354,685.807 520,683.5C 519.751,684.624 519.251,685.624 518.5,686.5C 518.089,685.738 517.923,684.738 518,683.5C 516.667,684.167 515.667,685.167 515,686.5C 514.692,685.692 514.192,685.025 513.5,684.5C 511.705,685.265 509.872,685.932 508,686.5C 504.632,686.478 501.132,686.311 497.5,686C 496.13,687.441 495.13,689.108 494.5,691C 492.464,691.454 490.63,692.287 489,693.5C 486.243,692.208 484.576,693.208 484,696.5C 483.275,694.842 482.108,694.342 480.5,695C 481.451,695.718 481.617,696.551 481,697.5C 480.163,695.993 478.996,695.493 477.5,696C 477.833,696.333 478.167,696.667 478.5,697C 477.54,698.419 476.707,699.919 476,701.5C 475.667,701.167 475.333,700.833 475,700.5C 474.626,701.416 474.126,702.25 473.5,703C 476.8,703.567 476.966,705.067 474,707.5C 473.667,707.167 473.333,706.833 473,706.5C 472.667,707.833 472.333,709.167 472,710.5C 471.282,709.549 470.449,709.383 469.5,710C 470.576,711.726 470.743,713.559 470,715.5C 469.086,714.346 468.253,714.513 467.5,716C 468.227,717.399 468.727,718.899 469,720.5C 469.333,720.167 469.667,719.833 470,719.5C 472.078,721.681 471.911,723.681 469.5,725.5C 468.604,724.494 467.938,724.494 467.5,725.5C 468.376,726.251 469.376,726.751 470.5,727C 470.167,727.333 469.833,727.667 469.5,728C 470.682,729.678 471.848,729.512 473,727.5C 474.563,728.102 474.396,728.935 472.5,730C 475.483,733.162 477.65,736.328 479,739.5C 479.667,736.833 480.333,736.833 481,739.5C 481.739,738.426 482.739,737.759 484,737.5C 486.363,739.029 488.197,741.029 489.5,743.5C 490.689,744.429 492.022,744.762 493.5,744.5C 493.491,746.308 493.991,747.975 495,749.5C 495.76,747.503 496.26,745.837 496.5,744.5C 497.799,745.09 498.632,746.09 499,747.5C 499.333,747.167 499.667,746.833 500,746.5C 500.49,747.793 500.657,749.127 500.5,750.5C 501.93,750.579 503.264,750.246 504.5,749.5C 504.833,750.167 505.167,750.833 505.5,751.5C 507.167,751.5 508.833,751.5 510.5,751.5C 511.308,751.808 511.975,752.308 512.5,753C 510.744,753.202 509.078,753.702 507.5,754.5C 507.667,754.833 507.833,755.167 508,755.5C 510.017,755.075 511.851,755.075 513.5,755.5C 514.696,755.846 514.696,756.346 513.5,757C 515.101,757.273 516.601,757.773 518,758.5C 520.178,755.532 521.344,755.865 521.5,759.5C 525.818,759.303 529.985,759.303 534,759.5C 534.5,758.333 535.333,757.5 536.5,757C 535.549,756.282 535.383,755.449 536,754.5C 537.011,755.337 538.178,755.67 539.5,755.5C 539.259,758.999 540.092,759.332 542,756.5C 543.019,757.687 544.186,758.687 545.5,759.5C 546.604,758.369 546.271,757.535 544.5,757C 545.766,756.691 546.933,756.191 548,755.5C 548.667,756.833 549.667,757.833 551,758.5C 551.635,754.898 552.968,754.232 555,756.5C 556.171,755.107 557.671,754.273 559.5,754C 557.888,753.28 556.388,753.446 555,754.5C 554.667,753.833 554.333,753.167 554,752.5C 553.107,753.711 552.274,753.711 551.5,752.5C 554.629,752.946 557.296,752.446 559.5,751C 558.549,750.282 558.383,749.449 559,748.5C 560.364,749.696 561.864,750.696 563.5,751.5C 566.578,751.376 567.578,750.043 566.5,747.5C 565.604,748.506 564.938,748.506 564.5,747.5C 565.025,746.808 565.692,746.308 566.5,746C 566.167,745.667 565.833,745.333 565.5,745C 566.772,743.693 567.772,742.193 568.5,740.5C 569.192,741.025 569.692,741.692 570,742.5C 570.374,741.584 570.874,740.75 571.5,740C 568.99,738.859 567.824,737.026 568,734.5C 569.011,735.337 570.178,735.67 571.5,735.5C 571.719,731.473 570.552,730.806 568,733.5C 566.148,731.77 566.314,730.604 568.5,730C 568.131,725.661 567.797,720.828 567.5,715.5C 569.582,715.472 571.416,716.139 573,717.5C 573.333,717.167 573.667,716.833 574,716.5C 575,718.833 576,721.167 577,723.5C 577.333,723.167 577.667,722.833 578,722.5C 578.333,723.5 578.667,724.5 579,725.5C 579.423,724.044 580.256,723.544 581.5,724C 582.573,725.594 583.573,727.094 584.5,728.5C 586.792,727.691 588.959,727.357 591,727.5C 591.456,728.744 590.956,729.577 589.5,730C 592.964,729.872 596.297,730.205 599.5,731C 598.833,731.333 598.167,731.667 597.5,732C 600.95,732.37 603.95,733.704 606.5,736C 606.087,737.537 606.087,739.204 606.5,741C 606.108,742.011 605.441,742.511 604.5,742.5C 606.567,743.134 608.4,744.134 610,745.5C 610.483,744.552 610.649,743.552 610.5,742.5C 612.429,742.231 614.095,742.731 615.5,744C 614.451,744.492 613.451,744.326 612.5,743.5C 611.359,745.421 611.192,747.421 612,749.5C 612.718,748.549 613.551,748.383 614.5,749C 613.289,749.893 613.289,750.726 614.5,751.5C 617.321,750.926 619.654,749.592 621.5,747.5C 623.217,748.668 623.884,750.335 623.5,752.5C 625.806,752.007 628.139,751.674 630.5,751.5C 630.607,753.379 630.107,753.712 629,752.5C 622.451,755.525 615.951,758.691 609.5,762C 608.386,763.57 607.053,764.903 605.5,766C 605.833,766.333 606.167,766.667 606.5,767C 603.596,768.555 600.93,770.555 598.5,773C 598.807,774.682 599.14,776.348 599.5,778C 599.333,778.5 599.167,779 599,779.5C 598.023,778.226 597.189,778.226 596.5,779.5C 593.857,778.47 591.19,778.303 588.5,779C 592.975,776.736 596.975,773.236 600.5,768.5C 599.624,767.749 598.624,767.249 597.5,767C 598.833,766 600.167,765 601.5,764C 600.338,763.173 599.171,762.34 598,761.5C 597.73,763.872 596.897,765.872 595.5,767.5C 594.667,766.5 593.833,765.5 593,764.5C 590.755,767.727 587.921,768.727 584.5,767.5C 582.626,767.39 581.126,768.056 580,769.5C 579.481,768.484 578.647,767.818 577.5,767.5C 575.545,768.453 573.878,769.787 572.5,771.5C 571.904,770.284 571.737,768.951 572,767.5C 570.413,768.727 569.079,768.394 568,766.5C 567.389,768.75 566.056,770.417 564,771.5C 563.667,771.167 563.333,770.833 563,770.5C 562.311,771.357 561.478,772.023 560.5,772.5C 557.708,771.555 555.208,771.555 553,772.5C 550.667,771.167 548.333,769.833 546,768.5C 543.788,769.65 541.621,770.65 539.5,771.5C 537.866,771.032 536.7,770.032 536,768.5C 535.586,768.957 535.086,769.291 534.5,769.5C 530.586,768.278 526.753,766.944 523,765.5C 521.467,765.944 519.967,766.277 518.5,766.5C 517.497,764.458 516.163,764.125 514.5,765.5C 514.331,764.603 513.998,763.603 513.5,762.5C 511.941,763.074 510.441,763.74 509,764.5C 507,762.167 504.5,760.667 501.5,760C 500.789,758.745 499.956,757.579 499,756.5C 498.667,757.167 498.333,757.833 498,758.5C 496.011,756.616 494.011,756.283 492,757.5C 490.59,756.213 489.09,755.046 487.5,754C 488.833,753.333 488.833,752.667 487.5,752C 485.021,751.106 482.688,750.773 480.5,751C 483.131,749.309 482.797,748.142 479.5,747.5C 480.002,746.284 480.335,745.117 480.5,744C 478.892,743.342 477.725,743.842 477,745.5C 476.612,744.572 475.945,743.905 475,743.5C 473.838,744.187 472.672,744.353 471.5,744C 472.284,738.206 469.618,735.206 463.5,735C 464.167,734.667 464.833,734.333 465.5,734C 464.044,733.577 463.544,732.744 464,731.5C 464.654,732.696 465.154,732.696 465.5,731.5C 464.273,730.41 463.44,729.076 463,727.5C 461.336,729.805 459.836,729.472 458.5,726.5C 458.709,725.914 459.043,725.414 459.5,725C 455.887,721.166 455.887,717.5 459.5,714C 458.833,713.667 458.167,713.333 457.5,713C 458.376,711.415 459.709,710.415 461.5,710C 460.672,709.085 459.672,708.419 458.5,708C 460.708,707.064 462.042,705.398 462.5,703C 464.246,702.529 465.913,701.862 467.5,701C 466.465,699.493 466.632,697.993 468,696.5C 468.667,695.167 469.333,695.167 470,696.5C 471.853,693.689 473.853,690.689 476,687.5C 476.333,687.833 476.667,688.167 477,688.5C 482.455,684.567 488.122,682.901 494,683.5C 495.101,681.606 496.434,680.939 498,681.5C 499,680.833 500,680.167 501,679.5C 505.218,679.264 509.551,679.597 514,680.5C 517.512,677.838 520.512,678.171 523,681.5C 525.463,681.749 527.13,681.082 528,679.5C 534.163,682.162 539.663,685.828 544.5,690.5C 549.784,693.137 554.784,696.137 559.5,699.5C 558.833,700.167 558.167,700.833 557.5,701.5C 559.193,702.228 560.693,703.228 562,704.5C 562.333,704.167 562.667,703.833 563,703.5C 567.335,706.208 568.502,709.874 566.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#032a7c",
    d: "M 803.5,669.5 C 812.212,670.126 820.878,671.126 829.5,672.5C 834.048,673.491 838.715,674.491 843.5,675.5C 844.263,676.268 845.263,676.768 846.5,677C 841.441,677.358 836.441,676.858 831.5,675.5C 826.266,676.031 821.1,676.698 816,677.5C 815.275,675.842 814.108,675.342 812.5,676C 805.462,682.707 798.128,689.04 790.5,695C 767.974,707.432 744.641,717.932 720.5,726.5C 719.761,726.631 719.094,726.464 718.5,726C 719.743,724.846 720.743,723.512 721.5,722C 719.009,721.374 719.009,720.541 721.5,719.5C 720.675,718.614 719.675,718.281 718.5,718.5C 726.771,714.854 734.438,711.187 741.5,707.5C 749.283,704.442 756.95,701.108 764.5,697.5C 765.492,697.672 766.158,697.338 766.5,696.5C 782.287,692.118 794.62,683.118 803.5,669.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#18468d",
    d: "M 881.5,697.5 C 881.369,696.761 881.536,696.094 882,695.5C 882.692,696.437 882.525,697.103 881.5,697.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#daedfe",
    d: "M 210.5,704.5 C 211.833,705.167 211.833,705.167 210.5,704.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d7eafd",
    d: "M 207.5,705.5 C 208.833,706.167 208.833,706.167 207.5,705.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#afd9f8",
    d: "M 337.5,705.5 C 336.833,706.167 336.833,706.167 337.5,705.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#14458d",
    d: "M 886.5,706.5 C 887.833,707.167 887.833,707.167 886.5,706.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d8effd",
    d: "M 211.5,708.5 C 210.833,709.167 210.833,709.167 211.5,708.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#aedbf8",
    d: "M 336.5,708.5 C 337.833,709.167 337.833,709.167 336.5,708.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#17468f",
    d: "M 886.5,708.5 C 887.833,709.167 887.833,709.167 886.5,708.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#acd6f7",
    d: "M 341.5,709.5 C 341.5,710.167 341.833,710.5 342.5,710.5C 342.44,711.043 342.107,711.376 341.5,711.5C 340.227,710.743 340.227,710.077 341.5,709.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#d9eefd",
    d: "M 212.5,710.5 C 211.833,711.167 211.833,711.167 212.5,710.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#add9f8",
    d: "M 338.5,710.5 C 339.833,711.167 339.833,711.167 338.5,710.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#aad6f8",
    d: "M 345.5,712.5 C 344.833,713.167 344.833,713.167 345.5,712.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#d7edfd",
    d: "M 211.5,713.5 C 212.833,714.167 212.833,714.167 211.5,713.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#aad8fa",
    d: "M 343.5,714.5 C 344.833,715.167 344.833,715.167 343.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#aad6f8",
    d: "M 347.5,714.5 C 347.5,714.833 347.5,715.167 347.5,715.5C 346.83,715.019 346.83,714.685 347.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#d9effe",
    d: "M 211.5,715.5 C 212.833,716.167 212.833,716.167 211.5,715.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#a7d6f8",
    d: "M 347.5,715.5 C 348.833,716.167 348.833,716.167 347.5,715.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a6d5f9",
    d: "M 351.5,717.5 C 351.631,718.239 351.464,718.906 351,719.5C 350.308,718.563 350.475,717.897 351.5,717.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#030f61",
    d: "M 741.5,707.5 C 734.438,711.187 726.771,714.854 718.5,718.5C 716.436,718.687 714.436,719.187 712.5,720C 669.5,720.667 626.5,720.667 583.5,720C 579.79,718.812 576.79,716.645 574.5,713.5C 574.624,712.893 574.957,712.56 575.5,712.5C 576.992,715.323 579.326,716.99 582.5,717.5C 624.998,718.705 667.665,719.205 710.5,719C 720.818,715.061 731.152,711.228 741.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#b7defb",
    d: "M 334.5,721.5 C 335.525,721.897 335.692,722.563 335,723.5C 334.536,722.906 334.369,722.239 334.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a6d5f8",
    d: "M 357.5,722.5 C 356.833,723.167 356.833,723.167 357.5,722.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#b7ddfc",
    d: "M 334.5,724.5 C 335.833,725.167 335.833,725.167 334.5,724.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a1d0f9",
    d: "M 359.5,727.5 C 359.897,726.475 360.563,726.308 361.5,727C 360.906,727.464 360.239,727.631 359.5,727.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#113c88",
    d: "M 886.5,726.5 C 887.833,727.167 887.833,727.167 886.5,726.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#043796",
    d: "M 843.5,675.5 C 846.63,675.7 849.63,676.366 852.5,677.5C 858.034,680.413 863.701,683.246 869.5,686C 875.746,690.501 879.079,696.501 879.5,704C 878.837,708.308 878.837,712.474 879.5,716.5C 878.957,721.747 876.791,726.08 873,729.5C 872.027,731.392 871.36,733.392 871,735.5C 867.333,737.833 864.333,740.833 862,744.5C 861,744.5 860,744.5 859,744.5C 857.436,746.263 856.269,748.263 855.5,750.5C 853.314,751.221 851.147,751.887 849,752.5C 848.667,752.167 848.333,751.833 848,751.5C 847.228,752.849 846.061,753.682 844.5,754C 845.167,754.333 845.833,754.667 846.5,755C 844.924,755.44 843.59,756.273 842.5,757.5C 841.914,757.291 841.414,756.957 841,756.5C 839.345,756.802 838.012,758.136 837,760.5C 834.601,760.028 832.601,761.028 831,763.5C 830.667,763.167 830.333,762.833 830,762.5C 828.068,764.038 825.901,765.205 823.5,766C 824.458,767.147 824.125,768.147 822.5,769C 820.212,769.822 817.878,770.489 815.5,771C 815.833,771.333 816.167,771.667 816.5,772C 814.5,772.667 812.5,773.333 810.5,774C 810.833,774.333 811.167,774.667 811.5,775C 807.831,774.299 804.164,774.632 800.5,776C 798.275,779.076 795.442,779.91 792,778.5C 791.641,781.544 790.974,781.878 790,779.5C 788.494,782.474 786.828,782.807 785,780.5C 784.626,781.416 784.126,782.25 783.5,783C 780.639,783.54 777.972,784.54 775.5,786C 773.517,787.889 771.184,789.222 768.5,790C 767.833,791 767.167,792 766.5,793C 742.747,800.31 719.414,807.81 696.5,815.5C 676.588,820.953 656.588,826.12 636.5,831C 627.522,832.165 618.522,833.165 609.5,834C 607.392,834.36 605.392,835.027 603.5,836C 604.448,836.483 605.448,836.649 606.5,836.5C 604.786,837.738 602.786,838.405 600.5,838.5C 600.918,837.778 601.584,837.278 602.5,837C 592.201,839.1 582.201,842.433 572.5,847C 568.833,847.667 565.167,847.667 561.5,847C 562.623,845.956 563.956,845.29 565.5,845C 566.738,844.31 566.738,843.81 565.5,843.5C 579.124,837.342 593.124,831.842 607.5,827C 611.996,826.148 616.33,826.648 620.5,828.5C 621.614,827.277 621.781,825.944 621,824.5C 617.057,814.004 612.723,803.671 608,793.5C 605.045,788.713 601.545,784.38 597.5,780.5C 599.736,781.389 601.736,782.722 603.5,784.5C 611.589,797.346 618.089,811.013 623,825.5C 623.202,823.744 623.702,822.078 624.5,820.5C 625.167,820.833 625.833,821.167 626.5,821.5C 627.833,820.5 629.167,819.5 630.5,818.5C 631.711,819.274 631.711,820.107 630.5,821C 631.766,821.309 632.933,821.809 634,822.5C 634.333,821.833 634.667,821.167 635,820.5C 636.587,821.727 637.921,821.394 639,819.5C 642.966,820.768 646.966,820.768 651,819.5C 653.321,816.083 655.988,815.75 659,818.5C 659.221,815.057 660.221,814.724 662,817.5C 663.552,816.034 665.386,815.034 667.5,814.5C 671.396,815.954 674.896,815.287 678,812.5C 679,812.833 680,813.167 681,813.5C 682.333,812.167 683.667,810.833 685,809.5C 685.689,810.357 686.522,811.023 687.5,811.5C 690.855,810.964 694.188,809.631 697.5,807.5C 698.768,808.428 700.101,808.595 701.5,808C 700.304,807.346 700.304,806.846 701.5,806.5C 704.643,806.359 707.476,806.692 710,807.5C 710.915,806.672 711.581,805.672 712,804.5C 712.308,805.308 712.808,805.975 713.5,806.5C 714.833,805.5 716.167,804.5 717.5,803.5C 716.624,802.749 715.624,802.249 714.5,802C 716.976,801.32 718.809,802.153 720,804.5C 721.717,803.545 723.384,802.545 725,801.5C 725.333,802.167 725.667,802.833 726,803.5C 727.487,802.747 727.654,801.914 726.5,801C 727.5,800.167 728.5,799.333 729.5,798.5C 728.754,797.264 728.421,795.93 728.5,794.5C 731.587,794.253 734.42,793.253 737,791.5C 737.333,791.833 737.667,792.167 738,792.5C 740.447,789.292 742.113,789.292 743,792.5C 744.29,790.208 745.957,788.208 748,786.5C 748,787.833 748,789.167 748,790.5C 748.957,787.978 750.457,785.811 752.5,784C 753.784,783.316 754.951,783.483 756,784.5C 756.333,783.833 756.667,783.167 757,782.5C 757.423,783.956 758.256,784.456 759.5,784C 759.043,783.586 758.709,783.086 758.5,782.5C 759.315,778.932 761.315,777.766 764.5,779C 763.366,777.984 763.699,777.317 765.5,777C 764.549,776.282 764.383,775.449 765,774.5C 765.915,775.328 766.581,776.328 767,777.5C 767.71,776.027 768.876,775.36 770.5,775.5C 770.351,774.448 770.517,773.448 771,772.5C 771.667,771.167 772.333,771.167 773,772.5C 773.507,773.996 773.007,775.163 771.5,776C 772.126,776.75 772.626,777.584 773,778.5C 774.333,775.833 775.667,773.167 777,770.5C 778.333,770.5 779.667,770.5 781,770.5C 782.154,769.257 783.488,768.257 785,767.5C 787,767.5 789,767.5 791,767.5C 793.761,766.501 795.094,764.501 795,761.5C 795.308,762.308 795.808,762.975 796.5,763.5C 798.271,762.965 798.604,762.131 797.5,761C 798.784,760.316 799.951,760.483 801,761.5C 801.419,760.328 802.085,759.328 803,758.5C 804.516,761.051 805.349,760.718 805.5,757.5C 808.278,757.978 810.278,756.978 811.5,754.5C 810.185,753.105 810.519,752.105 812.5,751.5C 812.998,752.603 813.331,753.603 813.5,754.5C 815.068,752.8 816.901,751.466 819,750.5C 819.333,749.5 819.667,748.5 820,747.5C 820.388,748.428 821.055,749.095 822,749.5C 823.168,748.491 824.335,747.491 825.5,746.5C 826.086,746.709 826.586,747.043 827,747.5C 827.359,744.456 828.026,744.122 829,746.5C 829.471,744.754 830.138,743.087 831,741.5C 831.333,742.5 831.667,743.5 832,744.5C 833.734,743.751 835.567,743.251 837.5,743C 836.5,742.667 835.5,742.333 834.5,742C 838.611,741.898 840.444,740.064 840,736.5C 840.667,735.167 841.333,735.167 842,736.5C 844.092,734.654 845.426,732.321 846,729.5C 846.308,730.308 846.808,730.975 847.5,731.5C 849.121,729.577 850.954,727.911 853,726.5C 853.308,727.308 853.808,727.975 854.5,728.5C 856.05,725.068 857.717,721.568 859.5,718C 858.576,716.189 857.743,716.355 857,718.5C 856.28,716.888 856.446,715.388 857.5,714C 856.833,713.667 856.167,713.333 855.5,713C 857.001,711.748 858.668,710.748 860.5,710C 856.67,709.593 856.003,708.26 858.5,706C 856.285,705.612 854.952,704.612 854.5,703C 855.167,702.333 855.833,701.667 856.5,701C 853.555,698.511 850.555,696.678 847.5,695.5C 845.98,696.85 845.313,698.183 845.5,699.5C 842.867,698.699 841.033,697.033 840,694.5C 839.282,695.451 838.449,695.617 837.5,695C 837.5,694 837.5,693 837.5,692C 834.488,691.425 832.321,692.591 831,695.5C 829.14,693.939 827.974,692.272 827.5,690.5C 827.598,691.616 827.098,692.616 826,693.5C 824.374,692.711 822.874,691.711 821.5,690.5C 820.522,690.977 819.689,691.643 819,692.5C 818.667,692.167 818.333,691.833 818,691.5C 817.667,692.5 817.333,693.5 817,694.5C 816,693.5 815,692.5 814,691.5C 810.771,692.345 807.438,693.678 804,695.5C 803.586,695.043 803.086,694.709 802.5,694.5C 802.167,695.167 801.833,695.833 801.5,696.5C 800.914,696.291 800.414,695.957 800,695.5C 799.667,696.833 799.333,698.167 799,699.5C 798.333,700.833 797.667,700.833 797,699.5C 795.954,701.09 794.787,702.59 793.5,704C 792.216,704.684 791.049,704.517 790,703.5C 789.517,704.448 789.351,705.448 789.5,706.5C 788.178,706.67 787.011,706.337 786,705.5C 785.667,706.5 785.333,707.5 785,708.5C 784.667,708.167 784.333,707.833 784,707.5C 783.097,708.701 781.931,709.535 780.5,710C 780.833,710.333 781.167,710.667 781.5,711C 779.22,711.703 777.22,712.869 775.5,714.5C 774.914,714.291 774.414,713.957 774,713.5C 773.935,715.883 773.102,716.55 771.5,715.5C 765.098,717.393 758.932,720.393 753,724.5C 753.077,723.262 752.911,722.262 752.5,721.5C 751.749,722.376 751.249,723.376 751,724.5C 750.439,723.978 749.772,723.645 749,723.5C 747.278,723.611 747.112,724.111 748.5,725C 746.899,725.273 745.399,725.773 744,726.5C 742.984,725.366 742.317,725.699 742,727.5C 739.772,726.701 738.439,727.701 738,730.5C 734.996,729.713 732.163,730.379 729.5,732.5C 727.223,732.015 725.056,732.681 723,734.5C 722.667,733.833 722.333,733.167 722,732.5C 720.202,734.837 718.035,735.503 715.5,734.5C 714.481,735.687 713.314,736.687 712,737.5C 710.984,736.366 710.317,736.699 710,738.5C 707.827,735.723 707.327,735.89 708.5,739C 706.729,741.113 705.229,740.947 704,738.5C 702.382,738.889 701.215,740.222 700.5,742.5C 699.304,742.154 699.304,741.654 700.5,741C 699.451,740.508 698.451,740.674 697.5,741.5C 697.891,740.109 697.058,739.109 695,738.5C 694.333,741.167 693.667,741.167 693,738.5C 692.261,739.574 691.261,740.241 690,740.5C 688.584,739.427 687.25,739.427 686,740.5C 685.692,739.692 685.192,739.025 684.5,738.5C 683.304,738.846 683.304,739.346 684.5,740C 682.35,742.704 680.184,742.871 678,740.5C 677.311,741.357 676.478,742.023 675.5,742.5C 674.117,739.924 673.283,740.258 673,743.5C 671.598,741.027 670.098,741.027 668.5,743.5C 666.786,742.391 666.119,743.058 666.5,745.5C 664.184,744.053 661.851,743.387 659.5,743.5C 656.678,744.149 654.845,745.815 654,748.5C 653.692,747.692 653.192,747.025 652.5,746.5C 651.114,748.644 649.614,749.977 648,750.5C 646.2,748.169 644.2,748.169 642,750.5C 639.6,750.692 637.1,750.359 634.5,749.5C 642.04,745.489 649.373,742.989 656.5,742C 657.469,740.242 658.636,739.742 660,740.5C 663.715,738.83 667.382,737.163 671,735.5C 672.716,736.552 673.716,735.886 674,733.5C 674.677,735.689 675.844,736.022 677.5,734.5C 678.478,734.977 679.311,735.643 680,736.5C 681.052,734.189 682.885,732.856 685.5,732.5C 691.439,732.329 697.106,732.329 702.5,732.5C 708.534,730.369 714.534,728.369 720.5,726.5C 744.641,717.932 767.974,707.432 790.5,695C 798.128,689.04 805.462,682.707 812.5,676C 814.108,675.342 815.275,675.842 816,677.5C 821.1,676.698 826.266,676.031 831.5,675.5C 836.441,676.858 841.441,677.358 846.5,677C 845.263,676.768 844.263,676.268 843.5,675.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#133e85",
    d: "M 885.5,729.5 C 885.897,728.475 886.563,728.308 887.5,729C 886.906,729.464 886.239,729.631 885.5,729.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#a0d4f7",
    d: "M 368.5,730.5 C 367.833,731.167 367.833,731.167 368.5,730.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#b9dffc",
    d: "M 333.5,731.5 C 334.833,732.167 334.833,732.167 333.5,731.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#a1d3f8",
    d: "M 372.5,733.5 C 372.5,733.833 372.5,734.167 372.5,734.5C 371.83,734.019 371.83,733.685 372.5,733.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a3d4f8",
    d: "M 367.5,734.5 C 368.833,735.167 368.833,735.167 367.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a1d1f7",
    d: "M 372.5,734.5 C 373.833,735.167 373.833,735.167 372.5,734.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a1d2f7",
    d: "M 376.5,736.5 C 375.833,737.167 375.833,737.167 376.5,736.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#94cefd",
    d: "M 472.5,750.5 C 482.816,756.995 493.482,762.995 504.5,768.5C 514.169,772.337 523.502,776.671 532.5,781.5C 520.504,787.332 508.17,792.332 495.5,796.5C 489.489,794.492 483.489,792.492 477.5,790.5C 476.07,789.463 474.403,788.796 472.5,788.5C 465.075,784.796 457.409,781.463 449.5,778.5C 447.151,776.659 444.485,775.326 441.5,774.5C 439.819,772.992 437.819,771.992 435.5,771.5C 435.158,770.662 434.492,770.328 433.5,770.5C 431.151,768.659 428.485,767.326 425.5,766.5C 423.819,764.992 421.819,763.992 419.5,763.5C 416.758,760.579 413.425,758.579 409.5,757.5C 408.101,756.11 406.434,755.11 404.5,754.5C 402.178,752.336 399.511,750.669 396.5,749.5C 395.312,748.636 394.145,747.636 393,746.5C 392.131,751.508 391.464,751.175 391,745.5C 389.259,744.242 387.426,743.242 385.5,742.5C 383.025,739.759 380.025,737.759 376.5,736.5C 375.738,734.738 374.404,733.738 372.5,733.5C 371.738,731.738 370.404,730.738 368.5,730.5C 365.019,727.591 361.352,724.925 357.5,722.5C 356.109,720.11 354.109,718.443 351.5,717.5C 350.738,715.738 349.404,714.738 347.5,714.5C 347.167,713.5 346.5,712.833 345.5,712.5C 345.027,711.094 344.027,710.427 342.5,710.5C 341.833,710.5 341.5,710.167 341.5,709.5C 340.5,707.833 339.167,706.5 337.5,705.5C 337.158,704.662 336.492,704.328 335.5,704.5C 336.895,691.409 338.228,678.076 339.5,664.5C 294.5,664.5 249.5,664.5 204.5,664.5C 250.998,663.667 297.665,663.167 344.5,663C 350.616,660.549 354.116,656.049 355,649.5C 355.418,638.084 349.918,632.418 338.5,632.5C 344.479,630.426 349.979,627.426 355,623.5C 382.459,653.956 413.625,679.789 448.5,701C 449.804,701.804 450.471,702.971 450.5,704.5C 446.545,725.256 453.878,740.589 472.5,750.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a1d2f9",
    d: "M 375.5,738.5 C 376.833,739.167 376.833,739.167 375.5,738.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#a2d2f8",
    d: "M 377.5,738.5 C 378.833,739.167 378.833,739.167 377.5,738.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#b9dffb",
    d: "M 333.5,739.5 C 334.833,740.167 334.833,740.167 333.5,739.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#a0d3f7",
    d: "M 379.5,739.5 C 380.833,740.167 380.833,740.167 379.5,739.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#daf0fd",
    d: "M 215.5,741.5 C 216.833,742.167 216.833,742.167 215.5,741.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#bae0fb",
    d: "M 332.5,741.5 C 333.525,741.897 333.692,742.563 333,743.5C 332.536,742.906 332.369,742.239 332.5,741.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.014
    },
    fill: "#9dcff8",
    d: "M 385.5,742.5 C 385.103,743.525 384.437,743.692 383.5,743C 384.094,742.536 384.761,742.369 385.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#bbe0fb",
    d: "M 331.5,747.5 C 332.598,748.601 332.765,749.934 332,751.5C 331.51,750.207 331.343,748.873 331.5,747.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9acff8",
    d: "M 396.5,749.5 C 396.103,750.525 395.437,750.692 394.5,750C 395.094,749.536 395.761,749.369 396.5,749.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#053085",
    d: "M 852.5,677.5 C 865.461,679.471 875.128,686.138 881.5,697.5C 890.422,717.151 886.756,733.984 870.5,748C 852.176,760.998 832.509,771.665 811.5,780C 798.987,785.06 786.321,789.727 773.5,794C 775.436,794.813 777.436,795.313 779.5,795.5C 783.257,798.135 787.257,799.635 791.5,800C 791.167,800.333 790.833,800.667 790.5,801C 792.584,801.697 794.251,802.864 795.5,804.5C 795.369,805.239 795.536,805.906 796,806.5C 800.128,809.385 803.794,812.719 807,816.5C 807.282,820.039 807.782,823.539 808.5,827C 808.167,827.5 807.833,828 807.5,828.5C 807.004,826.602 806.337,825.602 805.5,825.5C 802.78,820.447 798.78,816.78 793.5,814.5C 791.371,812.05 788.704,810.383 785.5,809.5C 783.784,807.975 781.784,806.975 779.5,806.5C 777.351,805.264 775.018,804.264 772.5,803.5C 769.715,801.905 766.715,800.905 763.5,800.5C 762.22,799.069 760.553,798.402 758.5,798.5C 754.633,798.242 750.966,798.908 747.5,800.5C 737.685,803.16 728.019,806.327 718.5,810C 715.528,814.749 713.862,819.915 713.5,825.5C 712.539,827.265 712.205,829.265 712.5,831.5C 708.496,831.365 704.496,830.865 700.5,830C 703.276,828.221 702.943,827.221 699.5,827C 699.833,826.667 700.167,826.333 700.5,826C 698.792,824.49 697.126,822.99 695.5,821.5C 695.977,820.522 696.643,819.689 697.5,819C 697.347,817.791 697.014,816.625 696.5,815.5C 719.414,807.81 742.747,800.31 766.5,793C 767.167,792 767.833,791 768.5,790C 771.184,789.222 773.517,787.889 775.5,786C 777.972,784.54 780.639,783.54 783.5,783C 784.126,782.25 784.626,781.416 785,780.5C 786.828,782.807 788.494,782.474 790,779.5C 790.974,781.878 791.641,781.544 792,778.5C 795.442,779.91 798.275,779.076 800.5,776C 804.164,774.632 807.831,774.299 811.5,775C 811.167,774.667 810.833,774.333 810.5,774C 812.5,773.333 814.5,772.667 816.5,772C 816.167,771.667 815.833,771.333 815.5,771C 817.878,770.489 820.212,769.822 822.5,769C 824.125,768.147 824.458,767.147 823.5,766C 825.901,765.205 828.068,764.038 830,762.5C 830.333,762.833 830.667,763.167 831,763.5C 832.601,761.028 834.601,760.028 837,760.5C 838.012,758.136 839.345,756.802 841,756.5C 841.414,756.957 841.914,757.291 842.5,757.5C 843.59,756.273 844.924,755.44 846.5,755C 845.833,754.667 845.167,754.333 844.5,754C 846.061,753.682 847.228,752.849 848,751.5C 848.333,751.833 848.667,752.167 849,752.5C 851.147,751.887 853.314,751.221 855.5,750.5C 856.269,748.263 857.436,746.263 859,744.5C 860,744.5 861,744.5 862,744.5C 864.333,740.833 867.333,737.833 871,735.5C 871.36,733.392 872.027,731.392 873,729.5C 876.791,726.08 878.957,721.747 879.5,716.5C 878.837,712.474 878.837,708.308 879.5,704C 879.079,696.501 875.746,690.501 869.5,686C 863.701,683.246 858.034,680.413 852.5,677.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#dceffa",
    d: "M 217.5,752.5 C 218.833,753.167 218.833,753.167 217.5,752.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9dcff8",
    d: "M 399.5,752.5 C 400.833,753.167 400.833,753.167 399.5,752.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#dceefe",
    d: "M 217.5,754.5 C 218.525,754.897 218.692,755.563 218,756.5C 217.536,755.906 217.369,755.239 217.5,754.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9dd0f8",
    d: "M 399.5,754.5 C 400.833,755.167 400.833,755.167 399.5,754.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#05338e",
    d: "M 533.5,667.5 C 533.833,667.5 534.167,667.5 534.5,667.5C 538.474,674.474 543.808,680.14 550.5,684.5C 557.123,690.313 564.79,694.313 573.5,696.5C 573.001,702.058 573.667,707.392 575.5,712.5C 574.957,712.56 574.624,712.893 574.5,713.5C 576.79,716.645 579.79,718.812 583.5,720C 626.5,720.667 669.5,720.667 712.5,720C 714.436,719.187 716.436,718.687 718.5,718.5C 719.675,718.281 720.675,718.614 721.5,719.5C 719.009,720.541 719.009,721.374 721.5,722C 720.743,723.512 719.743,724.846 718.5,726C 719.094,726.464 719.761,726.631 720.5,726.5C 714.534,728.369 708.534,730.369 702.5,732.5C 697.106,732.329 691.439,732.329 685.5,732.5C 682.885,732.856 681.052,734.189 680,736.5C 679.311,735.643 678.478,734.977 677.5,734.5C 675.844,736.022 674.677,735.689 674,733.5C 673.716,735.886 672.716,736.552 671,735.5C 667.382,737.163 663.715,738.83 660,740.5C 658.636,739.742 657.469,740.242 656.5,742C 649.373,742.989 642.04,745.489 634.5,749.5C 633.805,751.85 632.472,752.517 630.5,751.5C 628.139,751.674 625.806,752.007 623.5,752.5C 623.884,750.335 623.217,748.668 621.5,747.5C 619.654,749.592 617.321,750.926 614.5,751.5C 613.289,750.726 613.289,749.893 614.5,749C 613.551,748.383 612.718,748.549 612,749.5C 611.192,747.421 611.359,745.421 612.5,743.5C 613.451,744.326 614.451,744.492 615.5,744C 614.095,742.731 612.429,742.231 610.5,742.5C 610.649,743.552 610.483,744.552 610,745.5C 608.4,744.134 606.567,743.134 604.5,742.5C 605.441,742.511 606.108,742.011 606.5,741C 606.087,739.204 606.087,737.537 606.5,736C 603.95,733.704 600.95,732.37 597.5,732C 598.167,731.667 598.833,731.333 599.5,731C 596.297,730.205 592.964,729.872 589.5,730C 590.956,729.577 591.456,728.744 591,727.5C 588.959,727.357 586.792,727.691 584.5,728.5C 583.573,727.094 582.573,725.594 581.5,724C 580.256,723.544 579.423,724.044 579,725.5C 578.667,724.5 578.333,723.5 578,722.5C 577.667,722.833 577.333,723.167 577,723.5C 576,721.167 575,718.833 574,716.5C 573.667,716.833 573.333,717.167 573,717.5C 571.416,716.139 569.582,715.472 567.5,715.5C 567.5,714.833 567.167,714.5 566.5,714.5C 568.502,709.874 567.335,706.208 563,703.5C 562.667,703.833 562.333,704.167 562,704.5C 560.693,703.228 559.193,702.228 557.5,701.5C 558.167,700.833 558.833,700.167 559.5,699.5C 554.784,696.137 549.784,693.137 544.5,690.5C 539.663,685.828 534.163,682.162 528,679.5C 527.13,681.082 525.463,681.749 523,681.5C 520.512,678.171 517.512,677.838 514,680.5C 509.551,679.597 505.218,679.264 501,679.5C 500,680.167 499,680.833 498,681.5C 496.434,680.939 495.101,681.606 494,683.5C 488.122,682.901 482.455,684.567 477,688.5C 476.667,688.167 476.333,687.833 476,687.5C 473.853,690.689 471.853,693.689 470,696.5C 469.333,695.167 468.667,695.167 468,696.5C 466.632,697.993 466.465,699.493 467.5,701C 465.913,701.862 464.246,702.529 462.5,703C 462.042,705.398 460.708,707.064 458.5,708C 459.672,708.419 460.672,709.085 461.5,710C 459.709,710.415 458.376,711.415 457.5,713C 458.167,713.333 458.833,713.667 459.5,714C 455.887,717.5 455.887,721.166 459.5,725C 459.043,725.414 458.709,725.914 458.5,726.5C 459.836,729.472 461.336,729.805 463,727.5C 463.44,729.076 464.273,730.41 465.5,731.5C 465.154,732.696 464.654,732.696 464,731.5C 463.544,732.744 464.044,733.577 465.5,734C 464.833,734.333 464.167,734.667 463.5,735C 469.618,735.206 472.284,738.206 471.5,744C 472.672,744.353 473.838,744.187 475,743.5C 475.945,743.905 476.612,744.572 477,745.5C 477.725,743.842 478.892,743.342 480.5,744C 480.335,745.117 480.002,746.284 479.5,747.5C 482.797,748.142 483.131,749.309 480.5,751C 482.688,750.773 485.021,751.106 487.5,752C 488.833,752.667 488.833,753.333 487.5,754C 489.09,755.046 490.59,756.213 492,757.5C 494.011,756.283 496.011,756.616 498,758.5C 498.333,757.833 498.667,757.167 499,756.5C 499.956,757.579 500.789,758.745 501.5,760C 504.5,760.667 507,762.167 509,764.5C 510.441,763.74 511.941,763.074 513.5,762.5C 513.998,763.603 514.331,764.603 514.5,765.5C 516.163,764.125 517.497,764.458 518.5,766.5C 519.967,766.277 521.467,765.944 523,765.5C 526.753,766.944 530.586,768.278 534.5,769.5C 535.086,769.291 535.586,768.957 536,768.5C 536.7,770.032 537.866,771.032 539.5,771.5C 541.621,770.65 543.788,769.65 546,768.5C 548.333,769.833 550.667,771.167 553,772.5C 555.208,771.555 557.708,771.555 560.5,772.5C 561.478,772.023 562.311,771.357 563,770.5C 563.333,770.833 563.667,771.167 564,771.5C 566.056,770.417 567.389,768.75 568,766.5C 569.079,768.394 570.413,768.727 572,767.5C 571.737,768.951 571.904,770.284 572.5,771.5C 573.878,769.787 575.545,768.453 577.5,767.5C 578.647,767.818 579.481,768.484 580,769.5C 581.126,768.056 582.626,767.39 584.5,767.5C 587.921,768.727 590.755,767.727 593,764.5C 593.833,765.5 594.667,766.5 595.5,767.5C 596.897,765.872 597.73,763.872 598,761.5C 599.171,762.34 600.338,763.173 601.5,764C 600.167,765 598.833,766 597.5,767C 598.624,767.249 599.624,767.749 600.5,768.5C 596.975,773.236 592.975,776.736 588.5,779C 591.19,778.303 593.857,778.47 596.5,779.5C 597.167,779.5 597.5,779.833 597.5,780.5C 592.623,779.812 588.29,780.979 584.5,784C 586.5,785.667 588.5,787.333 590.5,789C 587.809,790.605 585.142,792.105 582.5,793.5C 579.828,794.501 577.162,795.501 574.5,796.5C 572.847,796.66 571.514,797.326 570.5,798.5C 567.673,799.108 565.007,800.108 562.5,801.5C 560.435,801.953 558.768,802.953 557.5,804.5C 554.62,804.94 551.954,805.94 549.5,807.5C 547.167,808.833 544.833,810.167 542.5,811.5C 530.771,817.016 527.771,825.683 533.5,837.5C 531.871,839.06 530.704,838.727 530,836.5C 529.667,837.167 529.333,837.833 529,838.5C 527.798,836.323 527.298,833.989 527.5,831.5C 526.5,831.5 525.5,831.5 524.5,831.5C 523.808,817.284 530.808,807.118 545.5,801C 552.51,798.161 559.51,795.327 566.5,792.5C 567.333,791.5 568.167,790.5 569,789.5C 569.333,789.833 569.667,790.167 570,790.5C 571.067,789.809 572.234,789.309 573.5,789C 561.612,784.755 550.112,780.589 539,776.5C 534.849,775.545 530.516,775.545 526,776.5C 522.213,774.704 519.879,771.704 519,767.5C 518.667,768.5 518.333,769.5 518,770.5C 515.876,769.773 513.709,769.106 511.5,768.5C 509.223,768.985 507.056,768.319 505,766.5C 504.536,767.094 504.369,767.761 504.5,768.5C 493.482,762.995 482.816,756.995 472.5,750.5C 464.062,743.894 457.229,735.894 452,726.5C 448.696,705.274 456.529,689.44 475.5,679C 494.819,675.027 514.153,671.193 533.5,667.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9ccff8",
    d: "M 404.5,754.5 C 404.631,755.239 404.464,755.906 404,756.5C 403.333,755.167 402.667,755.167 402,756.5C 401.812,754.939 402.645,754.272 404.5,754.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9acef9",
    d: "M 409.5,757.5 C 409.5,757.833 409.5,758.167 409.5,758.5C 406.833,758.167 406.833,757.833 409.5,757.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#113d89",
    d: "M 858.5,757.5 C 859.833,758.167 859.833,758.167 858.5,757.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9dcff6",
    d: "M 404.5,758.5 C 405.833,759.167 405.833,759.167 404.5,758.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9ad0f9",
    d: "M 409.5,758.5 C 410.833,759.167 410.833,759.167 409.5,758.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#ddeefb",
    d: "M 218.5,760.5 C 219.833,761.167 219.833,761.167 218.5,760.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d8edf9",
    d: "M 215.5,762.5 C 216.833,763.167 216.833,763.167 215.5,762.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#b9e1f8",
    d: "M 329.5,762.5 C 330.833,763.167 330.833,763.167 329.5,762.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9dcef7",
    d: "M 419.5,763.5 C 418.833,764.167 418.833,764.167 419.5,763.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#dcf0fa",
    d: "M 219.5,764.5 C 220.833,765.167 220.833,765.167 219.5,764.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#daeefb",
    d: "M 219.5,765.5 C 219.5,765.833 219.5,766.167 219.5,766.5C 218.83,766.019 218.83,765.685 219.5,765.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#dcf0fc",
    d: "M 219.5,766.5 C 220.833,767.167 220.833,767.167 219.5,766.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#99ccf7",
    d: "M 421.5,766.5 C 422.833,767.167 422.833,767.167 421.5,766.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#99ccf8",
    d: "M 425.5,766.5 C 425.103,767.525 424.437,767.692 423.5,767C 424.094,766.536 424.761,766.369 425.5,766.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9bcef8",
    d: "M 433.5,770.5 C 433.5,770.833 433.5,771.167 433.5,771.5C 432.662,771.842 432.328,772.508 432.5,773.5C 431.115,772.053 431.448,771.053 433.5,770.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#9bcdf7",
    d: "M 433.5,771.5 C 434.167,771.5 434.833,771.5 435.5,771.5C 434.833,772.833 434.167,772.833 433.5,771.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#daeef9",
    d: "M 220.5,771.5 C 221.525,771.897 221.692,772.563 221,773.5C 220.536,772.906 220.369,772.239 220.5,771.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#9bcdf7",
    d: "M 432.5,773.5 C 433.833,774.167 433.833,774.167 432.5,773.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.018
    },
    fill: "#97ccf8",
    d: "M 441.5,774.5 C 441.103,775.525 440.437,775.692 439.5,775C 440.094,774.536 440.761,774.369 441.5,774.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#baddf8",
    d: "M 326.5,778.5 C 327.833,779.167 327.833,779.167 326.5,778.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#97cdf3",
    d: "M 449.5,778.5 C 448.833,779.167 448.833,779.167 449.5,778.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#144091",
    d: "M 814.5,779.5 C 815.833,780.167 815.833,780.167 814.5,779.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#b9ddf8",
    d: "M 326.5,780.5 C 327.833,781.167 327.833,781.167 326.5,780.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#124091",
    d: "M 812.5,780.5 C 813.833,781.167 813.833,781.167 812.5,780.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#97c9f5",
    d: "M 455.5,782.5 C 454.833,781.167 454.833,781.167 455.5,782.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#bbddf9",
    d: "M 326.5,781.5 C 326.631,782.239 326.464,782.906 326,783.5C 325.308,782.563 325.475,781.897 326.5,781.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#96caf6",
    d: "M 455.5,782.5 C 456.239,782.369 456.906,782.536 457.5,783C 456.563,783.692 455.897,783.525 455.5,782.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#114292",
    d: "M 806.5,783.5 C 806.897,782.475 807.563,782.308 808.5,783C 807.906,783.464 807.239,783.631 806.5,783.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#daecf9",
    d: "M 225.5,786.5 C 226.833,787.167 226.833,787.167 225.5,786.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#94c8f5",
    d: "M 464.5,787.5 C 464.897,786.475 465.563,786.308 466.5,787C 465.906,787.464 465.239,787.631 464.5,787.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#2f5a9d",
    d: "M 545.5,786.5 C 546.833,787.167 546.833,787.167 545.5,786.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#95c7f4",
    d: "M 468.5,787.5 C 469.833,788.167 469.833,788.167 468.5,787.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2e5c9f",
    d: "M 547.5,787.5 C 548.833,788.167 548.833,788.167 547.5,787.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d6eef9",
    d: "M 229.5,789.5 C 228.833,790.167 228.833,790.167 229.5,789.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#bcdff5",
    d: "M 318.5,790.5 C 319.833,791.167 319.833,791.167 318.5,790.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#92c8f7",
    d: "M 472.5,788.5 C 473.797,791.603 473.464,791.937 471.5,789.5C 471.624,788.893 471.957,788.56 472.5,788.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#92c8f5",
    d: "M 477.5,790.5 C 476.749,791.573 475.749,791.74 474.5,791C 475.448,790.517 476.448,790.351 477.5,790.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#325ca1",
    d: "M 547.5,790.5 C 548.833,791.167 548.833,791.167 547.5,790.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2a59a4",
    d: "M 555.5,790.5 C 556.833,791.167 556.833,791.167 555.5,790.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#305fab",
    d: "M 557.5,791.5 C 558.833,792.167 558.833,792.167 557.5,791.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d9ebf9",
    d: "M 232.5,792.5 C 231.833,793.167 231.833,793.167 232.5,792.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3b65ab",
    d: "M 543.5,792.5 C 544.833,793.167 544.833,793.167 543.5,792.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2d60aa",
    d: "M 555.5,792.5 C 556.833,793.167 556.833,793.167 555.5,792.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.025
    },
    fill: "#2353a1",
    d: "M 779.5,794.5 C 778.761,794.631 778.094,794.464 777.5,794C 778.437,793.308 779.103,793.475 779.5,794.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d5eaf8",
    d: "M 231.5,794.5 C 232.833,795.167 232.833,795.167 231.5,794.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d8ebf9",
    d: "M 233.5,794.5 C 234.833,795.167 234.833,795.167 233.5,794.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3560a7",
    d: "M 550.5,794.5 C 551.833,795.167 551.833,795.167 550.5,794.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.016
    },
    fill: "#1e50a1",
    d: "M 779.5,794.5 C 780.833,795.167 780.833,795.167 779.5,794.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#d8eaf8",
    d: "M 236.5,795.5 C 235.833,796.167 235.833,796.167 236.5,795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#8fc1ed",
    d: "M 481.5,795.5 C 482.833,796.167 482.833,796.167 481.5,795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#8cbfed",
    d: "M 488.5,796.5 C 489.077,795.227 489.743,795.227 490.5,796.5C 490.03,797.463 489.363,797.463 488.5,796.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#224fa1",
    d: "M 782.5,795.5 C 783.833,796.167 783.833,796.167 782.5,795.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#c1def5",
    d: "M 307.5,797.5 C 307.5,797.167 307.5,796.833 307.5,796.5C 310.167,796.833 310.167,797.167 307.5,797.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#8bbfec",
    d: "M 492.5,796.5 C 493.833,797.167 493.833,797.167 492.5,796.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.007
    },
    fill: "#86b9eb",
    d: "M 497.5,797.5 C 498.251,796.427 499.251,796.26 500.5,797C 499.648,798.728 498.648,798.895 497.5,797.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d7e9f7",
    d: "M 237.5,798.5 C 236.833,797.167 236.833,797.167 237.5,798.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#bfdff5",
    d: "M 307.5,797.5 C 306.833,798.167 306.833,798.167 307.5,797.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#88bdec",
    d: "M 494.5,797.5 C 495.833,798.167 495.833,798.167 494.5,797.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d6e9f7",
    d: "M 237.5,798.5 C 238.833,799.167 238.833,799.167 237.5,798.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#89bcea",
    d: "M 492.5,798.5 C 493.833,799.167 493.833,799.167 492.5,798.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#4282f2",
    d: "M 597.5,780.5 C 601.545,784.38 605.045,788.713 608,793.5C 612.723,803.671 617.057,814.004 621,824.5C 621.781,825.944 621.614,827.277 620.5,828.5C 616.33,826.648 611.996,826.148 607.5,827C 593.124,831.842 579.124,837.342 565.5,843.5C 563.883,844.038 562.216,844.371 560.5,844.5C 554.742,833.313 548.742,822.313 542.5,811.5C 544.833,810.167 547.167,808.833 549.5,807.5C 557.753,815.096 564.086,824.096 568.5,834.5C 570.743,835.474 573.076,835.808 575.5,835.5C 575.106,829.703 573.272,824.37 570,819.5C 566.375,814.043 562.209,809.043 557.5,804.5C 558.768,802.953 560.435,801.953 562.5,801.5C 565.453,805.625 568.619,809.625 572,813.5C 575.53,819.9 579.03,826.233 582.5,832.5C 586.87,831.98 588.703,829.646 588,825.5C 586,821.5 584,817.5 582,813.5C 578.31,808.32 574.477,803.32 570.5,798.5C 571.514,797.326 572.847,796.66 574.5,796.5C 578.137,799.306 581.304,802.639 584,806.5C 587.118,813.239 590.618,819.739 594.5,826C 597.617,826.893 599.951,825.893 601.5,823C 596.535,812.219 590.202,802.385 582.5,793.5C 585.142,792.105 587.809,790.605 590.5,789C 588.5,787.333 586.5,785.667 584.5,784C 588.29,780.979 592.623,779.812 597.5,780.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d8ecf6",
    d: "M 249.5,800.5 C 250.833,801.167 250.833,801.167 249.5,800.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#cae2f3",
    d: "M 294.5,800.5 C 295.833,801.167 295.833,801.167 294.5,800.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d8eaf6",
    d: "M 251.5,801.5 C 252.833,802.167 252.833,802.167 251.5,801.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#dbeaf6",
    d: "M 255.5,801.5 C 255.103,802.525 254.437,802.692 253.5,802C 254.094,801.536 254.761,801.369 255.5,801.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#d6eaf7",
    d: "M 257.5,802.5 C 258.833,803.167 258.833,803.167 257.5,802.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#d7e9f9",
    d: "M 261.5,803.5 C 262.946,802.387 264.613,802.22 266.5,803C 264.866,803.494 263.199,803.66 261.5,803.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#d6e9f9",
    d: "M 267.5,803.5 C 268.601,802.402 269.934,802.235 271.5,803C 270.122,804.334 268.789,804.501 267.5,803.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#d3e9f8",
    d: "M 273.5,802.5 C 274.833,803.167 274.833,803.167 273.5,802.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#d3e6f8",
    d: "M 276.5,803.5 C 277.601,802.402 278.934,802.235 280.5,803C 279.207,803.49 277.873,803.657 276.5,803.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#93c7fe",
    d: "M 582.5,793.5 C 590.202,802.385 596.535,812.219 601.5,823C 599.951,825.893 597.617,826.893 594.5,826C 590.618,819.739 587.118,813.239 584,806.5C 581.304,802.639 578.137,799.306 574.5,796.5C 577.162,795.501 579.828,794.501 582.5,793.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#d5e9f8",
    d: "M 264.5,804.5 C 265.833,805.167 265.833,805.167 264.5,804.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#d5e8f6",
    d: "M 270.5,804.5 C 271.833,805.167 271.833,805.167 270.5,804.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#d1e4f6",
    d: "M 276.5,807.5 C 276.897,806.475 277.563,806.308 278.5,807C 277.906,807.464 277.239,807.631 276.5,807.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#93c7fe",
    d: "M 570.5,798.5 C 574.477,803.32 578.31,808.32 582,813.5C 584,817.5 586,821.5 588,825.5C 588.703,829.646 586.87,831.98 582.5,832.5C 579.03,826.233 575.53,819.9 572,813.5C 568.619,809.625 565.453,805.625 562.5,801.5C 565.007,800.108 567.673,799.108 570.5,798.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#91c6fe",
    d: "M 763.5,800.5 C 766.715,800.905 769.715,801.905 772.5,803.5C 764.977,811.202 759.477,820.202 756,830.5C 753.501,831.798 751.167,831.464 749,829.5C 750.085,823.632 752.085,817.966 755,812.5C 757.689,808.325 760.523,804.325 763.5,800.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#18499c",
    d: "M 806.5,810.5 C 807.833,811.167 807.833,811.167 806.5,810.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#90c6fe",
    d: "M 758.5,798.5 C 757.828,799.267 756.995,799.934 756,800.5C 751.306,809.226 746.639,817.893 742,826.5C 737.617,826.014 735.95,823.681 737,819.5C 739.99,812.85 743.49,806.516 747.5,800.5C 750.966,798.908 754.633,798.242 758.5,798.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#426db2",
    d: "M 519.5,817.5 C 520.525,817.897 520.692,818.563 520,819.5C 519.536,818.906 519.369,818.239 519.5,817.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#407ff2",
    d: "M 758.5,798.5 C 760.553,798.402 762.22,799.069 763.5,800.5C 760.523,804.325 757.689,808.325 755,812.5C 752.085,817.966 750.085,823.632 749,829.5C 751.167,831.464 753.501,831.798 756,830.5C 759.477,820.202 764.977,811.202 772.5,803.5C 775.018,804.264 777.351,805.264 779.5,806.5C 768.323,813.539 762.323,823.539 761.5,836.5C 763.371,837.767 765.204,837.767 767,836.5C 768.912,830.746 771.579,825.412 775,820.5C 779.067,817.381 782.567,813.715 785.5,809.5C 788.704,810.383 791.371,812.05 793.5,814.5C 787.267,824.624 781.267,834.957 775.5,845.5C 764.345,841.34 753.845,836.006 744,829.5C 742.989,829.892 742.489,830.559 742.5,831.5C 736.603,829.035 730.603,826.868 724.5,825C 720.756,824.071 717.256,824.571 714,826.5C 713.601,826.272 713.435,825.938 713.5,825.5C 713.862,819.915 715.528,814.749 718.5,810C 728.019,806.327 737.685,803.16 747.5,800.5C 743.49,806.516 739.99,812.85 737,819.5C 735.95,823.681 737.617,826.014 742,826.5C 746.639,817.893 751.306,809.226 756,800.5C 756.995,799.934 757.828,799.267 758.5,798.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#184794",
    d: "M 811.5,818.5 C 812.833,819.167 812.833,819.167 811.5,818.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#3b68ad",
    d: "M 521.5,819.5 C 522.525,819.897 522.692,820.563 522,821.5C 521.536,820.906 521.369,820.239 521.5,819.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#91c6fe",
    d: "M 779.5,806.5 C 781.784,806.975 783.784,807.975 785.5,809.5C 782.567,813.715 779.067,817.381 775,820.5C 771.579,825.412 768.912,830.746 767,836.5C 765.204,837.767 763.371,837.767 761.5,836.5C 762.323,823.539 768.323,813.539 779.5,806.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#194895",
    d: "M 812.5,820.5 C 813.833,821.167 813.833,821.167 812.5,820.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#92c5fe",
    d: "M 557.5,804.5 C 562.209,809.043 566.375,814.043 570,819.5C 573.272,824.37 575.106,829.703 575.5,835.5C 573.076,835.808 570.743,835.474 568.5,834.5C 564.086,824.096 557.753,815.096 549.5,807.5C 551.954,805.94 554.62,804.94 557.5,804.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.01
    },
    fill: "#184592",
    d: "M 813.5,822.5 C 816.001,822.511 816.168,823.178 814,824.5C 813.536,823.906 813.369,823.239 813.5,822.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#123b89",
    d: "M 814.5,830.5 C 815.833,831.167 815.833,831.167 814.5,830.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#15438b",
    d: "M 814.5,832.5 C 815.573,833.251 815.74,834.251 815,835.5C 814.517,834.552 814.351,833.552 814.5,832.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#0b2d7c",
    d: "M 533.5,837.5 C 540.787,846.239 549.787,848.572 560.5,844.5C 562.216,844.371 563.883,844.038 565.5,843.5C 566.738,843.81 566.738,844.31 565.5,845C 563.956,845.29 562.623,845.956 561.5,847C 565.167,847.667 568.833,847.667 572.5,847C 582.201,842.433 592.201,839.1 602.5,837C 601.584,837.278 600.918,837.778 600.5,838.5C 595.429,840.519 590.429,842.519 585.5,844.5C 574.693,849.159 563.526,852.492 552,854.5C 546.703,853.717 541.537,852.384 536.5,850.5C 534.777,848.782 532.777,847.449 530.5,846.5C 530.5,845.833 530.167,845.5 529.5,845.5C 528.189,842.865 526.522,840.531 524.5,838.5C 524.167,835.833 523.833,835.833 523.5,838.5C 522.709,836.691 522.709,834.691 523.5,832.5C 522.5,832.5 521.5,832.5 520.5,832.5C 520.768,829.881 520.435,827.381 519.5,825C 520,824.5 520.5,824 521,823.5C 521.333,826.167 521.667,828.833 522,831.5C 521.947,817.422 528.113,807.255 540.5,801C 548.3,797.828 555.634,794.661 562.5,791.5C 552.686,787.592 542.686,784.259 532.5,781.5C 523.502,776.671 514.169,772.337 504.5,768.5C 504.369,767.761 504.536,767.094 505,766.5C 507.056,768.319 509.223,768.985 511.5,768.5C 513.709,769.106 515.876,769.773 518,770.5C 518.333,769.5 518.667,768.5 519,767.5C 519.879,771.704 522.213,774.704 526,776.5C 530.516,775.545 534.849,775.545 539,776.5C 550.112,780.589 561.612,784.755 573.5,789C 572.234,789.309 571.067,789.809 570,790.5C 569.667,790.167 569.333,789.833 569,789.5C 568.167,790.5 567.333,791.5 566.5,792.5C 559.51,795.327 552.51,798.161 545.5,801C 530.808,807.118 523.808,817.284 524.5,831.5C 525.5,831.5 526.5,831.5 527.5,831.5C 527.298,833.989 527.798,836.323 529,838.5C 529.333,837.833 529.667,837.167 530,836.5C 530.704,838.727 531.871,839.06 533.5,837.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1c4894",
    d: "M 622.5,837.5 C 623.251,836.427 624.251,836.26 625.5,837C 624.552,837.483 623.552,837.649 622.5,837.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#174390",
    d: "M 710.5,836.5 C 711.833,837.167 711.833,837.167 710.5,836.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.006
    },
    fill: "#1a4793",
    d: "M 712.5,836.5 C 713.525,836.897 713.692,837.563 713,838.5C 712.536,837.906 712.369,837.239 712.5,836.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1a4692",
    d: "M 714.5,836.5 C 715.833,837.167 715.833,837.167 714.5,836.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#214f9e",
    d: "M 728.5,837.5 C 729.167,836.167 729.833,836.167 730.5,837.5C 729.833,837.5 729.167,837.5 728.5,837.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#063ea8",
    d: "M 542.5,811.5 C 548.742,822.313 554.742,833.313 560.5,844.5C 549.787,848.572 540.787,846.239 533.5,837.5C 527.771,825.683 530.771,817.016 542.5,811.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#2453a2",
    d: "M 607.5,838.5 C 607.897,837.475 608.563,837.308 609.5,838C 608.906,838.464 608.239,838.631 607.5,838.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1a4692",
    d: "M 626.5,837.5 C 627.833,838.167 627.833,838.167 626.5,837.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#22509c",
    d: "M 728.5,837.5 C 727.833,838.167 727.833,838.167 728.5,837.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2452a0",
    d: "M 730.5,837.5 C 731.833,838.167 731.833,838.167 730.5,837.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#275599",
    d: "M 523.5,838.5 C 523.833,838.5 524.167,838.5 524.5,838.5C 524.315,839.17 523.981,839.17 523.5,838.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#2053a2",
    d: "M 605.5,838.5 C 606.833,839.167 606.833,839.167 605.5,838.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1e4994",
    d: "M 615.5,838.5 C 616.833,839.167 616.833,839.167 615.5,838.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#07399c",
    d: "M 793.5,814.5 C 798.78,816.78 802.78,820.447 805.5,825.5C 806.995,833.191 804.661,839.357 798.5,844C 790.146,847.119 781.646,849.619 773,851.5C 760.188,846.677 747.688,841.177 735.5,835C 728.045,832.386 720.379,831.219 712.5,831.5C 712.205,829.265 712.539,827.265 713.5,825.5C 713.435,825.938 713.601,826.272 714,826.5C 717.256,824.571 720.756,824.071 724.5,825C 730.603,826.868 736.603,829.035 742.5,831.5C 742.489,830.559 742.989,829.892 744,829.5C 753.845,836.006 764.345,841.34 775.5,845.5C 781.267,834.957 787.267,824.624 793.5,814.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#153f86",
    d: "M 814.5,840.5 C 813.833,839.167 813.833,839.167 814.5,840.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#164087",
    d: "M 813.5,840.5 C 812.833,841.167 812.833,841.167 813.5,840.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#173f87",
    d: "M 814.5,840.5 C 815.833,841.167 815.833,841.167 814.5,840.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2553a1",
    d: "M 746.5,843.5 C 747.833,844.167 747.833,844.167 746.5,843.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#173e87",
    d: "M 810.5,843.5 C 811.833,844.167 811.833,844.167 810.5,843.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2757a5",
    d: "M 585.5,844.5 C 586.239,844.369 586.906,844.536 587.5,845C 586.563,845.692 585.897,845.525 585.5,844.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.009
    },
    fill: "#224e97",
    d: "M 529.5,845.5 C 530.167,845.5 530.5,845.833 530.5,846.5C 529.614,847.776 528.614,847.776 527.5,846.5C 527.957,845.702 528.624,845.369 529.5,845.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#2356a6",
    d: "M 581.5,847.5 C 581.897,846.475 582.563,846.308 583.5,847C 582.906,847.464 582.239,847.631 581.5,847.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#2555a6",
    d: "M 584.5,846.5 C 585.833,847.167 585.833,847.167 584.5,846.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#2052a2",
    d: "M 753.5,846.5 C 752.833,847.167 752.833,847.167 753.5,846.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#072a77",
    d: "M 795.5,804.5 C 799.646,806.073 803.313,808.407 806.5,811.5C 808.17,814.175 809.836,816.841 811.5,819.5C 814.352,827.641 814.019,835.641 810.5,843.5C 809.094,843.973 808.427,844.973 808.5,846.5C 799.272,854.187 788.605,857.021 776.5,855C 771.712,853.793 767.045,852.293 762.5,850.5C 759.697,848.785 756.697,847.452 753.5,846.5C 751.235,844.358 748.568,842.691 745.5,841.5C 745.167,842.167 744.833,842.833 744.5,843.5C 742.175,839.5 738.841,838 734.5,839C 737.167,838.333 737.167,837.667 734.5,837C 730.322,835.748 726.156,834.582 722,833.5C 716.989,835.284 711.822,835.784 706.5,835C 693.979,831.911 681.479,828.745 669,825.5C 655.557,828.902 642.057,832.069 628.5,835C 624.999,835.336 621.499,835.169 618,834.5C 614.114,834.931 610.28,835.597 606.5,836.5C 605.448,836.649 604.448,836.483 603.5,836C 605.392,835.027 607.392,834.36 609.5,834C 618.522,833.165 627.522,832.165 636.5,831C 656.588,826.12 676.588,820.953 696.5,815.5C 697.014,816.625 697.347,817.791 697.5,819C 696.643,819.689 695.977,820.522 695.5,821.5C 697.126,822.99 698.792,824.49 700.5,826C 700.167,826.333 699.833,826.667 699.5,827C 702.943,827.221 703.276,828.221 700.5,830C 704.496,830.865 708.496,831.365 712.5,831.5C 720.379,831.219 728.045,832.386 735.5,835C 747.688,841.177 760.188,846.677 773,851.5C 781.646,849.619 790.146,847.119 798.5,844C 804.661,839.357 806.995,833.191 805.5,825.5C 806.337,825.602 807.004,826.602 807.5,828.5C 807.833,828 808.167,827.5 808.5,827C 807.782,823.539 807.282,820.039 807,816.5C 803.794,812.719 800.128,809.385 796,806.5C 795.536,805.906 795.369,805.239 795.5,804.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#204d9c",
    d: "M 614.5,835.5 C 615.833,836.167 615.833,836.167 614.5,835.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#143c8b",
    d: "M 695.5,833.5 C 696.833,834.167 696.833,834.167 695.5,833.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#14418e",
    d: "M 683.5,831.5 C 683.897,830.475 684.563,830.308 685.5,831C 684.906,831.464 684.239,831.631 683.5,831.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#10408e",
    d: "M 652.5,831.5 C 653.251,830.427 654.251,830.26 655.5,831C 654.552,831.483 653.552,831.649 652.5,831.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#123f8f",
    d: "M 679.5,830.5 C 680.077,829.227 680.743,829.227 681.5,830.5C 681.03,831.463 680.363,831.463 679.5,830.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#133f8e",
    d: "M 656.5,829.5 C 657.833,830.167 657.833,830.167 656.5,829.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#174187",
    d: "M 808.5,846.5 C 809.833,847.167 809.833,847.167 808.5,846.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#204991",
    d: "M 536.5,850.5 C 536.5,850.833 536.5,851.167 536.5,851.5C 535.83,851.019 535.83,850.685 536.5,850.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#225099",
    d: "M 762.5,850.5 C 762.103,851.525 761.437,851.692 760.5,851C 761.094,850.536 761.761,850.369 762.5,850.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1f4b91",
    d: "M 536.5,851.5 C 537.833,852.167 537.833,852.833 536.5,853.5C 536.5,852.833 536.5,852.167 536.5,851.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#204b92",
    d: "M 536.5,853.5 C 535.833,854.167 535.833,854.167 536.5,853.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#224c9b",
    d: "M 562.5,853.5 C 563.833,854.167 563.833,854.167 562.5,853.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1e4c99",
    d: "M 767.5,853.5 C 768.525,853.897 768.692,854.563 768,855.5C 767.536,854.906 767.369,854.239 767.5,853.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#1c4b95",
    d: "M 544.5,854.5 C 545.833,855.167 545.833,855.167 544.5,854.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#214d9b",
    d: "M 769.5,854.5 C 770.833,855.167 770.833,855.167 769.5,854.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#13408b",
    d: "M 796.5,855.5 C 796.897,854.475 797.563,854.308 798.5,855C 797.906,855.464 797.239,855.631 796.5,855.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin2);
export default __webpack_public_path__ + "static/media/login2.c39c543f1ddac7d57ee20d4267278209.svg";
export { ForwardRef as ReactComponent };